import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import $ from 'jquery';
import io from "socket.io-client";
import Swal from "sweetalert2";
import { API_DOMAIN } from './globals'; // Import the global domain name

function MSPosition1() {

    const [UserType, setUserType] = useState("");
    const [UserName, setUserName] = useState("");
    const [matchSettings, setMatchSettings] = useState({});
    const [MatchBets, setMatchBets] = useState([]);
    const [SessionBets, setSessionBets] = useState([]);
    const [scoreSrc, setscoreSrc] = useState("");
    const [scoreID, setscoreID] = useState("");
    const [liveTVSrc, setliveTVSrc] = useState("");
    const [isLoaded, setIsLoaded] = useState(false);

    const [mySessionPosition, setSessionPosition] = useState([]);

    let TeamPM = ["0", "0", "0"];

    const [teamPM, setTeamPM] = useState(["0", "0", "0"]);

    const [allTeamPM, setAllTeamPM] = useState({
        Team1PM: 0,
        Team2PM: 0,
        Team3PM: 0,
    });

    // Function to update a specific team's value
    const updateTeamPM = (teamIndex, newValue) => {
        console.log("teamIndex=" + teamIndex + ", newValue=" + newValue);
        setTeamPM((prevTeamPM) => {
            const updatedTeamPM = [...prevTeamPM];
            updatedTeamPM[teamIndex] = newValue;
            return updatedTeamPM;
        });
    };

    const updateValues = (val1, val2) => {
        setTeamPM((prevTeamPM) => {
            const updatedTeamPM = [...prevTeamPM];
            updatedTeamPM[0] = val1;
            updatedTeamPM[1] = val2;
            return updatedTeamPM;
        });
    };

    const { MatchCode, MatchID } = useParams();
    if (MatchID == "")
        MatchID = 0;

    const [loading, setLoading] = useState(true);  // Loading state
    const [error, setError] = useState(null);  // Error state

    //const [bMbhavdata, setbMbhavdata] = useState([]);

    var LiveMessage = useRef("");
    var Mbhavdata = useRef([]);
    var bMbhavdata = useRef([]);
    var Fbhavdata = useRef([]);
    var Sbhavdata = useRef([]);
    var ShowMPM = useRef(true);

    var MatchShow = useRef(true);
    var BookMakerShow = useRef(true);
    var FancyShow = useRef(true);

    var LiveTVURL = useRef("");
    var CurrentBalls = useRef("");

    var res;
    var ServerTime_Formatted;
    var id = 0;

    var MatchName = "Test";
    var BookMakerMinAmount = 100;
    var BookMakerMaxAmount = 100000;

    let myVar1 = useRef(null);
    let myVar2 = useRef(null);

    //let matchSettings =useRef([]);

    let SessionMinAmount = useRef(null);
    let SessionMaxAmount = useRef(null);
    let Team1 = useRef(null);
    let Team2 = useRef(null);
    let Team3 = useRef(null);
    let MatchType = useRef(null);

    const [isExpanded, setIsExpanded] = useState(false);

    const toggleScoreHeight = () => {
        console.log($("#divScore").css('height'));
        // setIsExpanded((prev) => !prev);
        if ($("#divScore").css('height') == "130px")
            $("#divScore").css('height', '220');
        else
            $("#divScore").css('height', '130');
    };

    const scoreStyle = {
        height: isExpanded ? '270px' : '190px',
        //transition: 'height 0.3s ease', // Optional: For smooth transition
        //overflow: 'hidden', // Optional: Handle content overflow
    };

    const getHostName = () => {
        const uri = window.location.toString();
        let hostname = "";

        if (uri.indexOf(":") > 0) {
            hostname = new URL(uri).hostname;
        }

        const cleanUri = uri.substring(0, uri.indexOf(":"));
        if (cleanUri === "https") {
            hostname = `wss://${hostname}`;
        } else {
            hostname = `ws://${hostname}`;
        }

        console.log("hostname=" + hostname);

        return hostname + ":3000";
    };

    function getBhavData_sock1(mid, data) {

        if (mid != "") {

            res = $.parseJSON(data);

            var ServerTime = "";
            LiveMessage = data.LiveMessage;
            var t = res.CurrentTime.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            ServerTime = Date.parse(d);

            var myDate = d;
            ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
            $("#ServerTime_Formatted").val(ServerTime_Formatted);

            if (res.Match_Odds && res.Match_Odds.length != 0) {
                Mbhavdata = res.Match_Odds;
                MatchShow = true;
            } else {
                MatchShow = false;
            }

            //console.log( BookMakerShow +", "+res.BookMaker_Odds.length);
            if (res.BookMaker_Odds && res.BookMaker_Odds.length != 0) {
                bMbhavdata = res.BookMaker_Odds;
                BookMakerShow = true;
            } else {
                BookMakerShow = false;
            }

            if (res.Fancy_Odds && res.Fancy_Odds.length != 0) {
                Fbhavdata = res.Fancy_Odds;
                FancyShow = true;
            } else {
                FancyShow = false;
            }
            //console.log(Fbhavdata);

            if (MatchShow == true) {
                Mbhavdata.forEach((value, key) => {
                    id = key + 1;
                    var t = res.Match_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 10);
                    var MatchLTT = Date.parse(d);
                    if ($("#KRate" + id).val() != res.Match_Odds[key].KRate) {
                        $("#KRate" + id).removeClass('btn btn-warning ng-binding');
                        $("#KRate" + id).addClass('btn btn-success ng-binding');
                    }
                    else {
                        $("#KRate" + id).removeClass('btn btn-success ng-binding');
                        $("#KRate" + id).addClass('btn btn-warning ng-binding');
                    }

                    if ($("#LRate" + id).val() != res.Match_Odds[key].LRate) {
                        $("#LRate" + id).removeClass('btn btn-success ng-binding');
                        $("#LRate" + id).addClass('btn btn-warning ng-binding');
                    }
                    else {
                        $("#LRate" + id).removeClass('btn btn-warning ng-binding');
                        $("#LRate" + id).addClass('btn btn-success ng-binding');
                    }

                    if (res.Match_Odds[key].LockStatus != "Yes" && res.Match_Odds[key].DisplayStatus != "Yes" && ((MatchLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        Mbhavdata[key].KRate = res.Match_Odds[key].KRate;
                        Mbhavdata[key].LRate = res.Match_Odds[key].LRate;
                    } else {
                        Mbhavdata[key].KRate = "0";
                        Mbhavdata[key].LRate = "0";
                    }
                });
            }

            if (BookMakerShow == true) {
                bMbhavdata.forEach((value, key) => {
                    id = key + 1;
                    var t = res.BookMaker_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 10);
                    var BookMakerLTT = Date.parse(d);
                    if ($("#KRate_BM" + id).val() != res.BookMaker_Odds[key].KRate) {
                        $("#KRate_BM" + id).removeClass('btn btn-warning ng-binding');
                        $("#KRate_BM" + id).addClass('btn btn-success ng-binding');
                    }
                    else {
                        $("#KRate_BM" + id).removeClass('btn btn-success ng-binding');
                        $("#KRate_BM" + id).addClass('btn btn-warning ng-binding');
                    }

                    if ($("#LRate" + id).val() != res.BookMaker_Odds[key].LRate) {
                        $("#LRate_BM" + id).removeClass('btn btn-success ng-binding');
                        $("#LRate_BM" + id).addClass('btn btn-warning ng-binding');
                    }
                    else {
                        $("#LRate_BM" + id).removeClass('btn btn-warning ng-binding');
                        $("#LRate_BM" + id).addClass('btn btn-success ng-binding');
                    }

                    if (res.BookMaker_Odds[key].LockStatus != "Yes" && res.BookMaker_Odds[key].DisplayStatus != "Yes" && ((BookMakerLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        bMbhavdata[key].KRate = res.BookMaker_Odds[key].KRate;
                        bMbhavdata[key].LRate = res.BookMaker_Odds[key].LRate;

                        if (bMbhavdata[key].KRate == "0.00")
                            bMbhavdata[key].KRate = "0";
                        if (bMbhavdata[key].LRate == "0.00")
                            bMbhavdata[key].LRate = "0";
                    } else {
                        bMbhavdata[key].KRate = "0";
                        bMbhavdata[key].LRate = "0";
                    }

                });
            }

            if (FancyShow == true) {

                Fbhavdata.forEach(function (item, index) {
                    Fbhavdata[index].originalIndex = index + 1;
                });

                Fbhavdata.forEach(function (value, key) {
                    id = key + 1;

                    //var SessionBitTime=res.Fancy_Odds[key].LastUpdateTime;
                    var t = res.Fancy_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 8);
                    var SessionLTT = Date.parse(d);

                    if ($("#NRun" + id).val() != res.Fancy_Odds[key].NRun) {
                        $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#NRun" + id).addClass('btn btn-success ng-binding ');
                    }
                    else {
                        $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#NRun" + id).addClass('btn btn-warning ng-binding ');
                    }

                    if ($("#YRun" + id).val() != res.Fancy_Odds[key].YRun) {
                        $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                    }
                    else {
                        $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#YRun" + id).addClass('btn btn-success ng-binding ');
                    }

                    Fbhavdata[key].SessionName = res.Fancy_Odds[key].SessionName;

                    var NRun = 0, NRate = "0.00", YRun = 0, YRate = "0.00";

                    if (res.Fancy_Odds[key].LockStatus != "Yes" && res.Fancy_Odds[key].DisplayStatus != "Yes" && ((SessionLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        Fbhavdata[key].NRun = res.Fancy_Odds[key].NRun;
                        Fbhavdata[key].YRun = res.Fancy_Odds[key].YRun;

                        Fbhavdata[key].NRate = res.Fancy_Odds[key].NRate;
                        Fbhavdata[key].YRate = res.Fancy_Odds[key].YRate;

                        $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#NRun" + id).addClass('btn btn-warning ng-binding ');

                        $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#YRun" + id).addClass('btn btn-success ng-binding ');
                    } else {
                        Fbhavdata[key].NRun = "0";
                        Fbhavdata[key].YRun = "0";

                        Fbhavdata[key].NRate = "0.00";
                        Fbhavdata[key].YRate = "0.00";

                        $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#NRun" + id).addClass('btn btn-success ng-binding ');

                        $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                    }
                });
            }

            if (res.Score) {
                Sbhavdata = res.Score;
                if (res.Score[0].Commentary == "" || res.Score[0].Commentary == " " || res.Score[0].Commentary == "../images/Commentary/")
                    $("#Image").html("<img src='../images/Commentary/Blank.png?' width='53' style='height:80px;'/>");
                else
                    $("#Image").html("<img src='../images/Commentary/" + res.Score[0].Commentary + "?' width='53' style='height:80px;'/>");
                CurrentBalls = res.Score[0].CurrentOverBalls1 + " " + res.Score[0].CurrentOverBalls2 + " " + res.Score[0].CurrentOverBalls3 + " " + res.Score[0].CurrentOverBalls4 + " " + res.Score[0].CurrentOverBalls5 + " " + res.Score[0].CurrentOverBalls6;
                //console.log("'"+CurrentBalls+"'");
                if (CurrentBalls != "     ")
                    CurrentBalls = "6 Balls : " + CurrentBalls;
                if (res.Score[0].Message == "Match Declared")
                    window.location = '/Dashboard';
            }

        }

    }

    function getBhavData(mid) {

        if (mid != "") {

            let url=`${API_DOMAIN}/api/odds/php/getBhav_${MatchCode}.php`;
            $("#apiURL").html(url);

            $.get(url, function (data) {
                res = (data);
                $("#SocketData").html("ApiData=" + JSON.stringify(res));
                $("#ApiData").val(JSON.stringify(res));

                if (res) {
                    var ServerTime = "";
                    LiveMessage = data.LiveMessage;
                    var t = res.CurrentTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    ServerTime = Date.parse(d);

                    var myDate = d;
                    ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
                    $("#ServerTime_Formatted").val(ServerTime_Formatted);

                    if (res.Match_Odds && res.Match_Odds.length != 0) {
                        Mbhavdata = res.Match_Odds;
                        MatchShow = true;
                    } else {
                        MatchShow = false;
                    }

                    //console.log( BookMakerShow +", "+res.BookMaker_Odds.length);
                    if (res.BookMaker_Odds && res.BookMaker_Odds.length != 0) {
                        //setbMbhavdata(res.BookMaker_Odds);
                        bMbhavdata = res.BookMaker_Odds;
                        BookMakerShow = true;
                    } else {
                        BookMakerShow = false;
                    }
                    //console.log(bMbhavdata);

                    if (res.Fancy_Odds && res.Fancy_Odds.length != 0) {
                        Fbhavdata = res.Fancy_Odds;
                        FancyShow = true;
                    } else {
                        FancyShow = false;

                    }
                    //console.log(Fbhavdata);

                    if (MatchShow == true) {
                        Mbhavdata.forEach((value, key) => {
                            id = key + 1;
                            var t = res.Match_Odds[key].LastUpdateTime.split(/[- :]/);
                            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                            d.setSeconds(d.getSeconds() + 10);
                            var MatchLTT = Date.parse(d);
                            if ($("#KRate" + id).val() != res.Match_Odds[key].KRate) {
                                $("#KRate" + id).removeClass('btn btn-warning ng-binding');
                                $("#KRate" + id).addClass('btn btn-success ng-binding');
                            }
                            else {
                                $("#KRate" + id).removeClass('btn btn-success ng-binding');
                                $("#KRate" + id).addClass('btn btn-warning ng-binding');
                            }

                            if ($("#LRate" + id).val() != res.Match_Odds[key].LRate) {
                                $("#LRate" + id).removeClass('btn btn-success ng-binding');
                                $("#LRate" + id).addClass('btn btn-warning ng-binding');
                            }
                            else {
                                $("#LRate" + id).removeClass('btn btn-warning ng-binding');
                                $("#LRate" + id).addClass('btn btn-success ng-binding');
                            }

                            if (res.Match_Odds[key].LockStatus != "Yes" && res.Match_Odds[key].DisplayStatus != "Yes" && ((MatchLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                                Mbhavdata[key].KRate = res.Match_Odds[key].KRate;
                                Mbhavdata[key].LRate = res.Match_Odds[key].LRate;
                            } else {
                                Mbhavdata[key].KRate = "0";
                                Mbhavdata[key].LRate = "0";
                            }
                        });
                    }

                    var KRate1data = "";
                    var LRate1data = "";

                    var KRate2data = "";
                    var LRate2data = "";

                    var FavTeam = "";
                    var KRate = 0;
                    var LRate = 0;
                    var BMBhavDataJSON = '';
                    var teamid = 0;
                    var TeamPMColor = "black";

                    if (BookMakerShow == true) {
                        bMbhavdata.forEach((value, key) => {
                            id = key + 1;
                            var t = res.BookMaker_Odds[key].LastUpdateTime.split(/[- :]/);
                            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                            d.setSeconds(d.getSeconds() + 10);
                            var BookMakerLTT = Date.parse(d);
                            if ($("#KRate_BM" + id).val() != res.BookMaker_Odds[key].KRate) {
                                $("#KRate_BM" + id).removeClass('btn btn-warning ng-binding');
                                $("#KRate_BM" + id).addClass('btn btn-success ng-binding');
                            }
                            else {
                                $("#KRate_BM" + id).removeClass('btn btn-success ng-binding');
                                $("#KRate_BM" + id).addClass('btn btn-warning ng-binding');
                            }

                            if ($("#LRate" + id).val() != res.BookMaker_Odds[key].LRate) {
                                $("#LRate_BM" + id).removeClass('btn btn-success ng-binding');
                                $("#LRate_BM" + id).addClass('btn btn-warning ng-binding');
                            }
                            else {
                                $("#LRate_BM" + id).removeClass('btn btn-warning ng-binding');
                                $("#LRate_BM" + id).addClass('btn btn-success ng-binding');
                            }

                            if (res.BookMaker_Odds[key].LockStatus != "Yes" && res.BookMaker_Odds[key].DisplayStatus != "Yes" && ((BookMakerLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                                bMbhavdata[key].KRate = res.BookMaker_Odds[key].KRate;
                                bMbhavdata[key].LRate = res.BookMaker_Odds[key].LRate;

                                if (bMbhavdata[key].KRate == "0.00")
                                    bMbhavdata[key].KRate = "0";
                                if (bMbhavdata[key].LRate == "0.00")
                                    bMbhavdata[key].LRate = "0";
                            } else {
                                bMbhavdata[key].KRate = "0";
                                bMbhavdata[key].LRate = "0";
                            }

                            FavTeam = res.BookMaker_Odds[key].FavTeam;
                            KRate = bMbhavdata[key].KRate;
                            LRate = bMbhavdata[key].LRate;
                            TeamPMColor = TeamPM[teamid] > 0 ? 'green' : TeamPM[teamid] < 0 ? 'red' : 'black';

                            // console.log("TeamPM=" + TeamPM);
                            // console.log("allTeamPM.Team1PM=" + allTeamPM.Team1PM);
                            // console.log("teamPM=" + teamPM);

                            if (id == 1) {
                                var Team1BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                                if (KRate === '0' && LRate === '0') {
                                    Team1BackLay += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                                }

                                $("#Team1BackLay").html(Team1BackLay);
                            } else if (id == 2) {
                                var Team2BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                                if (KRate === '0' && LRate === '0') {
                                    Team2BackLay += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                                }

                                $("#Team2BackLay").html(Team2BackLay);
                            } else if (id == 3) {
                                var Team3BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';
                                $("#Team3BackLay").html(Team3BackLay);
                            }

                            //BMBhavDataJSON += '<div class="f-prio2"> <div class="fancy-rows list-item"> <div class="event-sports event-sports-name"> <div class="event-name" style="margin-left: 0px; color: rgb(0, 0, 0); font-weight: 700; display: block;"> <img src="/images/team1.png"> <span>' + FavTeam + '</span> <br> <div style="color: '+TeamPMColor+'" id="Team_BM' + id + 'PM">'+TeamPM[teamid]+'</div> </div> </div> <div class="fancy_div"> <span class="fbox35270"> <div class="fancy_buttone"> <div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate* 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate* 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div> </div> </span>';

                            // if (KRate === '0' && LRate === '0') {
                            //     BMBhavDataJSON += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                            // }

                            // BMBhavDataJSON += " </div> </div> </div>";

                            //$("#BMBhavDataJSON").html(BMBhavDataJSON);

                            teamid++;

                        });
                    } else {
                        var Team1BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                        //console.log("KRate=" + KRate + ", LRate=" + LRate);

                        if (KRate == '0' && LRate == '0') {
                            Team1BackLay += '<div class="ball-running-msg" > <h1>API STOPPED</h1> </div>';
                        }

                        $("#Team1BackLay").html(Team1BackLay);

                        var Team2BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                        if (KRate == '0' && LRate == '0') {
                            Team2BackLay += '<div class="ball-running-msg" > <h1>API STOPPED</h1> </div>';
                        }

                        $("#Team2BackLay").html(Team2BackLay);
                    }

                    var SessionName = "";
                    var Remark = "";
                    var NRun = 0;
                    var NRate = 0;
                    var YRun = 0;
                    var YRate = 0;
                    var FancyBhavDataJSON = '';

                    if (FancyShow == true) {

                        Fbhavdata.forEach(function (item, index) {
                            Fbhavdata[index].originalIndex = index + 1;
                        });

                        Fbhavdata.forEach(function (value, key) {
                            id = key + 1;

                            //var SessionBitTime=res.Fancy_Odds[key].LastUpdateTime;
                            var t = res.Fancy_Odds[key].LastUpdateTime.split(/[- :]/);
                            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                            d.setSeconds(d.getSeconds() + 8);
                            var SessionLTT = Date.parse(d);

                            if ($("#NRun" + id).val() != res.Fancy_Odds[key].NRun) {
                                $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                                $("#NRun" + id).addClass('btn btn-success ng-binding ');
                            }
                            else {
                                $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                                $("#NRun" + id).addClass('btn btn-warning ng-binding ');
                            }

                            if ($("#YRun" + id).val() != res.Fancy_Odds[key].YRun) {
                                $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                                $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                            }
                            else {
                                $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                                $("#YRun" + id).addClass('btn btn-success ng-binding ');
                            }

                            Fbhavdata[key].SessionName = res.Fancy_Odds[key].SessionName;

                            var NRun = 0, NRate = "0.00", YRun = 0, YRate = "0.00";

                            if (res.Fancy_Odds[key].LockStatus != "Yes" && res.Fancy_Odds[key].DisplayStatus != "Yes" && ((SessionLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                                Fbhavdata[key].NRun = res.Fancy_Odds[key].NRun;
                                Fbhavdata[key].YRun = res.Fancy_Odds[key].YRun;

                                Fbhavdata[key].NRate = res.Fancy_Odds[key].NRate;
                                Fbhavdata[key].YRate = res.Fancy_Odds[key].YRate;

                                $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                                $("#NRun" + id).addClass('btn btn-warning ng-binding ');

                                $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                                $("#YRun" + id).addClass('btn btn-success ng-binding ');
                            } else {
                                Fbhavdata[key].NRun = "0";
                                Fbhavdata[key].YRun = "0";

                                Fbhavdata[key].NRate = "0.00";
                                Fbhavdata[key].YRate = "0.00";

                                $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                                $("#NRun" + id).addClass('btn btn-success ng-binding ');

                                $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                                $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                            }

                            SessionName = res.Fancy_Odds[key].SessionName;
                            NRun = Fbhavdata[key].NRun;
                            NRate = Fbhavdata[key].NRate;

                            YRun = Fbhavdata[key].YRun;
                            YRate = Fbhavdata[key].YRate;

                            Remark = Fbhavdata[key].Remark;

                            FancyBhavDataJSON += '<div class="f-prio2"> <div class="fancy-rows list-item"> <div class="event-sports event-sports-name"> <span class="event-name"  style="margin-left: 0px; color: rgb(0, 0, 0); font-weight: 700; font-size: 13px; display: block;"> <span style="text-transform: capitalize;" class="ng-binding">' + SessionName + '</span> <input type="hidden" id="Session' + id + '" name="Session' + id + '" value="' + SessionName + '"> <input type="hidden" id="Min' + id + '" name="Min' + id + '" value="' + res.Fancy_Odds[key].Min + '"> <input type="hidden" id="Max' + id + '" name="Max' + id + '" value="' + res.Fancy_Odds[key].Max + '"><span class="btn btn-sm FancyBook" BookId="' + id + '" style="float: right; font-size: 12px; font-weight: 900;background-color:green;color:white;">Book</span><br><span style="font-size:11px;color:green;">Min : ' + res.Fancy_Odds[key].Min + '</span>, <span style="font-size:11px;color:red;">Max : ' + res.Fancy_Odds[key].Max + '</span> <!--<span style="float: right; margin-right: 10px;" id=""> <img style="width: 15px;" src="/images/info.png"> </span>--> </span> </div> <div class="fancy_div"> <span> <div class="fancy_buttone"> <div class="fancy-lays bet-button lay mark-lay FancyNot" NotId="' + id + '"> <strong><span class="ng-binding">' + NRun + '</span></strong> <div class="size"> <span class="ng-binding">' + (NRate * 100).toFixed(0) + '</span> </div> <input type="hidden" id="NRun' + id + '" name="NRun' + id + '" value="' + NRun + '"> <input type="hidden" id="NRate' + id + '" name="NRate' + id + '" value="' + NRate + '"> </div> <div class="fancy-backs bet-button back mark-back FancyYes" YesId="' + id + '"> <strong><span class="ng-binding">' + YRun + '</span></strong> <div class="size"> <span class="ng-binding">' + (YRate * 100).toFixed(0) + '</span> </div> <input type="hidden" id="YRun' + id + '" name="YRun' + id + '" value="' + YRun + '"> <input type="hidden" id="YRate' + id + '" name="YRate' + id + '" value="' + YRate + '"> </div> </div> </span> ';

                            //console.log("SessionName=" + SessionName + ", NRate=" + NRate + ", YRate=" + YRate);

                            if (parseFloat(NRate) == 0 || parseFloat(YRate) == 0) {
                                FancyBhavDataJSON += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                            }

                            FancyBhavDataJSON += " </div> </div> </div>";

                            if (Remark != "") {
                                FancyBhavDataJSON += '<div class="f-prio2" align="left"> <span style="color:red;text-align:right;font-weight:bold;">' + Remark + '</span> </div>';
                            }

                            $("#FancyBhavDataJSON").html(FancyBhavDataJSON);

                        });
                    } else {
                        //console.log("Fancy Clear");
                        $("#FancyBhavDataJSON").html("");
                    }

                    if (res.Score) {
                        Sbhavdata = res.Score;
                        if (res.Score[0].Commentary == "" || res.Score[0].Commentary == " " || res.Score[0].Commentary == "../images/Commentary/")
                            $("#Image").html("<img src='../images/Commentary/Blank.png?' width='53' style='height:80px;'/>");
                        else
                            $("#Image").html("<img src='../images/Commentary/" + res.Score[0].Commentary + "?' width='53' style='height:80px;'/>");
                        CurrentBalls = res.Score[0].CurrentOverBalls1 + " " + res.Score[0].CurrentOverBalls2 + " " + res.Score[0].CurrentOverBalls3 + " " + res.Score[0].CurrentOverBalls4 + " " + res.Score[0].CurrentOverBalls5 + " " + res.Score[0].CurrentOverBalls6;
                        //console.log("'"+CurrentBalls+"'");
                        if (CurrentBalls != "     ")
                            CurrentBalls = "6 Balls : " + CurrentBalls;
                        if (res.Score[0].Message == "Match Declared")
                            window.location = '/Dashboard';
                    }
                } else {
                    $("#FancyBhavDataJSON").html(`Data Not Found : ${API_DOMAIN}/api/odds/php/getBhav_${MatchCode}.php`);
                    $("#apiURL").html("Data Not Found : "+url);
                }

            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error("jqXHR="+JSON.stringify(jqXHR));
                $("#ErrorData").html("Error fetching data : "+JSON.stringify(jqXHR)+", textStatus="+textStatus+", errorThrown="+errorThrown+"<br>");
                //alert("Failed to retrieve data. Please try again later.");
            });
        }

    }

    function getBhavData_Socket(data) {

        res=data;

        if (res) {
            //console.log(res);
            var ServerTime = "";
            LiveMessage = data.LiveMessage;
            var t = res.CurrentTime.split(/[- :]/);
            var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            ServerTime = Date.parse(d);

            var myDate = d;
            ServerTime_Formatted = myDate.getFullYear() + '-' + ('0' + (myDate.getMonth() + 1)).slice(-2) + '-' + ('0' + myDate.getDate()).slice(-2) + ' ' + myDate.getHours() + ':' + ('0' + (myDate.getMinutes())).slice(-2) + ':' + myDate.getSeconds();
            $("#ServerTime_Formatted").val(ServerTime_Formatted);

            if (res.Match_Odds && res.Match_Odds.length != 0) {
                Mbhavdata = res.Match_Odds;
                MatchShow = true;
            } else {
                MatchShow = false;
            }

            //console.log( BookMakerShow +", "+res.BookMaker_Odds.length);
            if (res.BookMaker_Odds && res.BookMaker_Odds.length != 0) {
                //setbMbhavdata(res.BookMaker_Odds);
                bMbhavdata = res.BookMaker_Odds;
                BookMakerShow = true;
            } else {
                BookMakerShow = false;
            }
            //console.log(bMbhavdata);

            if (res.Fancy_Odds && res.Fancy_Odds.length != 0) {
                Fbhavdata = res.Fancy_Odds;
                FancyShow = true;
            } else {
                FancyShow = false;

            }
            
            //console.log(Fbhavdata);

            if (MatchShow == true) {
                Mbhavdata.forEach((value, key) => {
                    id = key + 1;
                    var t = res.Match_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 10);
                    var MatchLTT = Date.parse(d);
                    if ($("#KRate" + id).val() != res.Match_Odds[key].KRate) {
                        $("#KRate" + id).removeClass('btn btn-warning ng-binding');
                        $("#KRate" + id).addClass('btn btn-success ng-binding');
                    }
                    else {
                        $("#KRate" + id).removeClass('btn btn-success ng-binding');
                        $("#KRate" + id).addClass('btn btn-warning ng-binding');
                    }

                    if ($("#LRate" + id).val() != res.Match_Odds[key].LRate) {
                        $("#LRate" + id).removeClass('btn btn-success ng-binding');
                        $("#LRate" + id).addClass('btn btn-warning ng-binding');
                    }
                    else {
                        $("#LRate" + id).removeClass('btn btn-warning ng-binding');
                        $("#LRate" + id).addClass('btn btn-success ng-binding');
                    }

                    if (res.Match_Odds[key].LockStatus != "Yes" && res.Match_Odds[key].DisplayStatus != "Yes" && ((MatchLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        Mbhavdata[key].KRate = res.Match_Odds[key].KRate;
                        Mbhavdata[key].LRate = res.Match_Odds[key].LRate;
                    } else {
                        Mbhavdata[key].KRate = "0";
                        Mbhavdata[key].LRate = "0";
                    }
                });
            }

            var KRate1data = "";
            var LRate1data = "";

            var KRate2data = "";
            var LRate2data = "";

            var FavTeam = "";
            var KRate = 0;
            var LRate = 0;
            var BMBhavDataJSON = '';
            var teamid = 0;
            var TeamPMColor = "black";

            if (BookMakerShow == true) {
                bMbhavdata.forEach((value, key) => {
                    id = key + 1;
                    var t = res.BookMaker_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 10);
                    var BookMakerLTT = Date.parse(d);
                    if ($("#KRate_BM" + id).val() != res.BookMaker_Odds[key].KRate) {
                        $("#KRate_BM" + id).removeClass('btn btn-warning ng-binding');
                        $("#KRate_BM" + id).addClass('btn btn-success ng-binding');
                    }
                    else {
                        $("#KRate_BM" + id).removeClass('btn btn-success ng-binding');
                        $("#KRate_BM" + id).addClass('btn btn-warning ng-binding');
                    }

                    if ($("#LRate" + id).val() != res.BookMaker_Odds[key].LRate) {
                        $("#LRate_BM" + id).removeClass('btn btn-success ng-binding');
                        $("#LRate_BM" + id).addClass('btn btn-warning ng-binding');
                    }
                    else {
                        $("#LRate_BM" + id).removeClass('btn btn-warning ng-binding');
                        $("#LRate_BM" + id).addClass('btn btn-success ng-binding');
                    }

                    if (res.BookMaker_Odds[key].LockStatus != "Yes" && res.BookMaker_Odds[key].DisplayStatus != "Yes" && ((BookMakerLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        bMbhavdata[key].KRate = res.BookMaker_Odds[key].KRate;
                        bMbhavdata[key].LRate = res.BookMaker_Odds[key].LRate;

                        if (bMbhavdata[key].KRate == "0.00")
                            bMbhavdata[key].KRate = "0";
                        if (bMbhavdata[key].LRate == "0.00")
                            bMbhavdata[key].LRate = "0";
                    } else {
                        bMbhavdata[key].KRate = "0";
                        bMbhavdata[key].LRate = "0";
                    }

                    FavTeam = res.BookMaker_Odds[key].FavTeam;
                    KRate = bMbhavdata[key].KRate;
                    LRate = bMbhavdata[key].LRate;
                    TeamPMColor = TeamPM[teamid] > 0 ? 'green' : TeamPM[teamid] < 0 ? 'red' : 'black';

                    // console.log("TeamPM=" + TeamPM);
                    // console.log("allTeamPM.Team1PM=" + allTeamPM.Team1PM);
                    // console.log("teamPM=" + teamPM);

                    if (id == 1) {
                        var Team1BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                        if (KRate === '0' && LRate === '0') {
                            Team1BackLay += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                        }

                        $("#Team1BackLay").html(Team1BackLay);
                    } else if (id == 2) {
                        var Team2BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                        if (KRate === '0' && LRate === '0') {
                            Team2BackLay += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                        }

                        $("#Team2BackLay").html(Team2BackLay);
                    } else if (id == 3) {
                        var Team3BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';
                        $("#Team3BackLay").html(Team3BackLay);
                    }

                    //BMBhavDataJSON += '<div class="f-prio2"> <div class="fancy-rows list-item"> <div class="event-sports event-sports-name"> <div class="event-name" style="margin-left: 0px; color: rgb(0, 0, 0); font-weight: 700; display: block;"> <img src="/images/team1.png"> <span>' + FavTeam + '</span> <br> <div style="color: '+TeamPMColor+'" id="Team_BM' + id + 'PM">'+TeamPM[teamid]+'</div> </div> </div> <div class="fancy_div"> <span class="fbox35270"> <div class="fancy_buttone"> <div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate* 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate* 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div> </div> </span>';

                    // if (KRate === '0' && LRate === '0') {
                    //     BMBhavDataJSON += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                    // }

                    // BMBhavDataJSON += " </div> </div> </div>";

                    //$("#BMBhavDataJSON").html(BMBhavDataJSON);

                    teamid++;

                });
            } else {
                var Team1BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                console.log("KRate=" + KRate + ", LRate=" + LRate);

                if (KRate == '0' && LRate == '0') {
                    Team1BackLay += '<div class="ball-running-msg" > <h1>API STOPPED</h1> </div>';
                }

                $("#Team1BackLay").html(Team1BackLay);

                var Team2BackLay = '<div class="fancy-backs bet-button back mark-back BMK" style="padding: 15px; user-select: none;" rt="' + KRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (KRate * 100).toFixed(0) + '</span> </strong> <input class="button_k" type="hidden" id="KRate_BM' + id + '" name="KRate_BM' + id + '" value="' + KRate + '"> </div> <div class="fancy-lays bet-button lay mark-lay BML" style="padding: 15px; user-select: none;" rt="' + LRate + '" teamid="' + id + '"> <strong> <span class="ng-binding">' + (LRate * 100).toFixed(0) + '</span></strong> <input class="button_l" type="hidden" id="LRate_BM' + id + '" name="LRate_BM' + id + '" value="' + LRate + '"> </div>';

                if (KRate == '0' && LRate == '0') {
                    Team2BackLay += '<div class="ball-running-msg" > <h1>API STOPPED</h1> </div>';
                }

                $("#Team2BackLay").html(Team2BackLay);
            }

            var SessionName = "";
            var Remark = "";
            var NRun = 0;
            var NRate = 0;
            var YRun = 0;
            var YRate = 0;
            var FancyBhavDataJSON = '';

            if (FancyShow == true) {

                Fbhavdata.forEach(function (item, index) {
                    Fbhavdata[index].originalIndex = index + 1;
                });

                Fbhavdata.forEach(function (value, key) {
                    id = key + 1;

                    //var SessionBitTime=res.Fancy_Odds[key].LastUpdateTime;
                    var t = res.Fancy_Odds[key].LastUpdateTime.split(/[- :]/);
                    var d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
                    d.setSeconds(d.getSeconds() + 8);
                    var SessionLTT = Date.parse(d);

                    if ($("#NRun" + id).val() != res.Fancy_Odds[key].NRun) {
                        $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#NRun" + id).addClass('btn btn-success ng-binding ');
                    }
                    else {
                        $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#NRun" + id).addClass('btn btn-warning ng-binding ');
                    }

                    if ($("#YRun" + id).val() != res.Fancy_Odds[key].YRun) {
                        $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                    }
                    else {
                        $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#YRun" + id).addClass('btn btn-success ng-binding ');
                    }

                    Fbhavdata[key].SessionName = res.Fancy_Odds[key].SessionName;

                    var NRun = 0, NRate = "0.00", YRun = 0, YRate = "0.00";

                    if (res.Fancy_Odds[key].LockStatus != "Yes" && res.Fancy_Odds[key].DisplayStatus != "Yes" && ((SessionLTT) >= (ServerTime)) && res.EmgLock != "Yes") {
                        Fbhavdata[key].NRun = res.Fancy_Odds[key].NRun;
                        Fbhavdata[key].YRun = res.Fancy_Odds[key].YRun;

                        Fbhavdata[key].NRate = res.Fancy_Odds[key].NRate;
                        Fbhavdata[key].YRate = res.Fancy_Odds[key].YRate;

                        $("#NRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#NRun" + id).addClass('btn btn-warning ng-binding ');

                        $("#YRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#YRun" + id).addClass('btn btn-success ng-binding ');
                    } else {
                        Fbhavdata[key].NRun = "0";
                        Fbhavdata[key].YRun = "0";

                        Fbhavdata[key].NRate = "0.00";
                        Fbhavdata[key].YRate = "0.00";

                        $("#NRun" + id).removeClass('btn btn-warning ng-binding ')
                        $("#NRun" + id).addClass('btn btn-success ng-binding ');

                        $("#YRun" + id).removeClass('btn btn-success ng-binding ')
                        $("#YRun" + id).addClass('btn btn-warning ng-binding ');
                    }

                    SessionName = res.Fancy_Odds[key].SessionName;
                    NRun = Fbhavdata[key].NRun;
                    NRate = Fbhavdata[key].NRate;

                    YRun = Fbhavdata[key].YRun;
                    YRate = Fbhavdata[key].YRate;

                    Remark = Fbhavdata[key].Remark;

                    FancyBhavDataJSON += '<div class="f-prio2"> <div class="fancy-rows list-item"> <div class="event-sports event-sports-name"> <span class="event-name"  style="margin-left: 0px; color: rgb(0, 0, 0); font-weight: 700; font-size: 13px; display: block;"> <span style="text-transform: capitalize;" class="ng-binding">' + SessionName + '</span> <input type="hidden" id="Session' + id + '" name="Session' + id + '" value="' + SessionName + '"> <input type="hidden" id="Min' + id + '" name="Min' + id + '" value="' + res.Fancy_Odds[key].Min + '"> <input type="hidden" id="Max' + id + '" name="Max' + id + '" value="' + res.Fancy_Odds[key].Max + '"><span class="btn btn-sm FancyBook" BookId="' + id + '" style="float: right; font-size: 12px; font-weight: 900;background-color:green;color:white;">Book</span><br><span style="font-size:11px;color:green;">Min : ' + res.Fancy_Odds[key].Min + '</span>, <span style="font-size:11px;color:red;">Max : ' + res.Fancy_Odds[key].Max + '</span> <!--<span style="float: right; margin-right: 10px;" id=""> <img style="width: 15px;" src="/images/info.png"> </span>--> </span> </div> <div class="fancy_div"> <span> <div class="fancy_buttone"> <div class="fancy-lays bet-button lay mark-lay FancyNot" NotId="' + id + '"> <strong><span class="ng-binding">' + NRun + '</span></strong> <div class="size"> <span class="ng-binding">' + (NRate * 100).toFixed(0) + '</span> </div> <input type="hidden" id="NRun' + id + '" name="NRun' + id + '" value="' + NRun + '"> <input type="hidden" id="NRate' + id + '" name="NRate' + id + '" value="' + NRate + '"> </div> <div class="fancy-backs bet-button back mark-back FancyYes" YesId="' + id + '"> <strong><span class="ng-binding">' + YRun + '</span></strong> <div class="size"> <span class="ng-binding">' + (YRate * 100).toFixed(0) + '</span> </div> <input type="hidden" id="YRun' + id + '" name="YRun' + id + '" value="' + YRun + '"> <input type="hidden" id="YRate' + id + '" name="YRate' + id + '" value="' + YRate + '"> </div> </div> </span> ';

                    //console.log("SessionName=" + SessionName + ", NRate=" + NRate + ", YRate=" + YRate);

                    if (parseFloat(NRate) == 0 || parseFloat(YRate) == 0) {
                        FancyBhavDataJSON += '<div class="ball-running-msg" > <h1>SUSPENDED</h1> </div>';
                    }

                    FancyBhavDataJSON += " </div> </div> </div>";

                    if (Remark != "") {
                        FancyBhavDataJSON += '<div class="f-prio2" align="left"> <span style="color:red;text-align:right;font-weight:bold;">' + Remark + '</span> </div>';
                    }

                    $("#FancyBhavDataJSON").html(FancyBhavDataJSON);

                });
            } else {
                //console.log("Fancy Clear");
                $("#FancyBhavDataJSON").html("");
            }

            if (res.Score) {
                Sbhavdata = res.Score;
                if (res.Score[0].Commentary == "" || res.Score[0].Commentary == " " || res.Score[0].Commentary == "../images/Commentary/")
                    $("#Image").html("<img src='../images/Commentary/Blank.png?' width='53' style='height:80px;'/>");
                else
                    $("#Image").html("<img src='../images/Commentary/" + res.Score[0].Commentary + "?' width='53' style='height:80px;'/>");
                CurrentBalls = res.Score[0].CurrentOverBalls1 + " " + res.Score[0].CurrentOverBalls2 + " " + res.Score[0].CurrentOverBalls3 + " " + res.Score[0].CurrentOverBalls4 + " " + res.Score[0].CurrentOverBalls5 + " " + res.Score[0].CurrentOverBalls6;
                //console.log("'"+CurrentBalls+"'");
                if (CurrentBalls != "     ")
                    CurrentBalls = "6 Balls : " + CurrentBalls;
                if (res.Score[0].Message == "Match Declared")
                    window.location = '/Dashboard';
            }
        } else {
            $("#FancyBhavDataJSON").html(`Data Not Found : ${API_DOMAIN}/api/odds/php/getBhav_${MatchCode}.php`);
        }

    }

    $(document).off("click", ".FancyBook").on("click", ".FancyBook", function (e) {
        
        var id = $(this).attr('BookId');

        console.log("id="+id+", SessionName=" + $("#Session"+id).val());

        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2, mc: MatchCode, sn: $("#Session"+id).val() };

        const queryStringMSBets = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getSessionPosition.php?${queryStringMSBets}`;

        //console.log(url);

        fetch(url, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    console.log(data.result);
                    //setSessionPosition(Array.isArray(data.result[0].SessionPM) ? data.result[0].SessionPM : []);
                    setSessionPosition(Array.isArray(data?.result?.[0]?.SessionPM) ? data.result[0].SessionPM : []);
                    $("#SessionPosition").css("display","block");
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
                //console.log("err="+err);
            });
        
    });

    $(document).off("click", ".BMK").on("click", ".BMK", function (e) {
        clearInterval(myVar1);
        clearInterval(myVar2);

        var id = $(this).attr('teamid');

        console.log("teamid=" + id);

        if ($("#KRate_BM" + id).val() == "0")
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: "No Any Rate Were Found For Placing Bet.",
                showConfirmButton: true
            });
        else {
            $("#BetTeamindex").val(id);
            $("#DisplayBhavType" + id).val("BookMaker");
            $("#myModalLabel").html('<strong><div><div class="h6 p-0 m-0">' + $("#Team" + id).val() + '</div></div></strong>');

            $("#Rate_Odds").html("Rate");
            $("#Mode_Odds").html("Mode");

            $("#Rate2_Odds").html("Lagai");

            $("#MatchBetChk").val("K");
            $("#MatchRate").val($("#KRate_BM" + id).val());
            $("#MatchTeam").val($("#Team" + id).val());
            //console.log($("#Team"+id).val()+", "+$("#KRate_BM"+id).val())
            $("#KLRate").val("LRate_BM" + id);
            $("#MBetType").val("BookMaker_Odds");

            $("#TeamKRate").val($("#KRate_BM" + id).val());
            $("#TeamLRate").val($("#LRate_BM" + id).val());
            $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

            document.getElementById("AmountTimeChk").value = "Yes";
            //document.getElementById("AmountTime").className = "AmountTime";

            $("#Timer").css('display', 'none');
            var $window = $(window);
            var windowsize = $window.width();
            //console.log(windowsize);
            if (windowsize >= 500) {
                $("#betSlipBoxSession").css('display', 'block');
                $("#DisplayBhavName").html($("#Team" + id).val());
                $("#Rate1_Odds").val($("#KRate_BM" + id).val());
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("cmdDone").style.visibility = "visible";
                document.getElementById("MatchAmount").value = "";
                document.getElementById("MatchAmount").readOnly = false;
                $("#betBoxColor").css('background-color', 'rgb(114, 187, 239)');
            } else {
                $("#betSlipBoxSessionMob").css('display', 'block');
                $("#DisplayBhavNameMob").html($("#Team" + id).val());
                $("#Rate1_OddsMob").val($("#KRate_BM" + id).val());
                document.getElementById("cmdDoneMob").disabled = false;
                document.getElementById("cmdDoneMob").style.visibility = "visible";
                document.getElementById("MatchAmountMob").value = "";
                document.getElementById("MatchAmountMob").readOnly = false;
                $("#betBoxColorMob").css('background-color', 'rgb(114, 187, 239)');
            }

            //document.BetPlayer.AmountTime.value="8";
            $("#AmountTime").html(10);
            $("#AmountTimeMob").html(10);
            //console.log("BTBM="+matchSettings.BTBM);
            document.getElementById("MatchAmount").focus();
            //myVar1 = setInterval(function () { AmountTimeMatch() }, 1000);

            myVar1 = setInterval(() => {
                AmountTimeMatch();
            }, 1000);

            // setTimeout(function () {
            //     $("#AmountTime").html(parseInt($("#AmountTime").html()) - 1);
            //     $("#AmountTimeMob").html(parseInt($("#AmountTimeMob").html()) - 1);

            //     console.log("setTimeout, AmountTime='" + $("#AmountTime").html()+"'");

            // }, 3000);


        }
    });

    $(document).off("click", ".BML").on("click", ".BML", function (e) {
        clearInterval(myVar1);
        clearInterval(myVar2);

        var id = $(this).attr('teamid');

        console.log("teamid=" + id);

        if ($("#LRate_BM" + id).val() == "0")
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: "No Any Rate Were Found For Placing Bet.",
                showConfirmButton: true
            });
        else {
            $("#BetTeamindex").val(id);
            $("#DisplayBhavType" + id).val("BookMaker");
            $("#myModalLabel").html('<strong><div><div class="h6 p-0 m-0">' + $("#Team" + id).val() + '</div></div></strong>');

            $("#Rate_Odds").html("Rate");
            $("#Mode_Odds").html("Mode");

            $("#Rate2_Odds").html("Khai");

            $("#MatchBetChk").val("L");
            $("#MatchRate").val($("#LRate_BM" + id).val());
            $("#MatchTeam").val($("#Team" + id).val());
            //console.log($("#Team"+id).val()+", "+$("#KRate"+id).val())
            $("#KLRate").val("KRate_BM" + id);
            $("#MBetType").val("BookMaker_Odds");

            $("#TeamKRate").val($("#KRate_BM" + id).val());
            $("#TeamLRate").val($("#LRate_BM" + id).val());
            $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

            document.getElementById("AmountTimeChk").value = "Yes";
            //document.getElementById("AmountTime").className = "AmountTime";

            $("#Timer").css('display', 'none');
            var $window = $(window);
            var windowsize = $window.width();
            //console.log(windowsize);
            if (windowsize >= 500) {
                $("#betSlipBoxSession").css('display', 'block');
                $("#DisplayBhavName").html($("#Team" + id).val());
                $("#Rate1_Odds").val($("#LRate_BM" + id).val());
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("cmdDone").style.visibility = "visible";
                document.getElementById("MatchAmount").value = "";
                document.getElementById("MatchAmount").readOnly = false;
                $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
            } else {
                $("#betSlipBoxSessionMob").css('display', 'block');
                $("#DisplayBhavNameMob").html($("#Team" + id).val());
                $("#Rate1_OddsMob").val($("#LRate_BM" + id).val());
                document.getElementById("cmdDoneMob").disabled = false;
                document.getElementById("cmdDoneMob").style.visibility = "visible";
                document.getElementById("MatchAmountMob").value = "";
                document.getElementById("MatchAmountMob").readOnly = false;
                $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
            }

            //document.BetPlayer.AmountTime.value="8";
            $("#AmountTime").html(10);
            $("#AmountTimeMob").html(10);
            document.getElementById("MatchAmount").focus();
            //myVar1 = setInterval(function () { AmountTimeMatch() }, 1000);

            myVar1 = setInterval(() => {
                AmountTimeMatch();
            }, 1000);

        }
    });

    $(document).off("click", ".FancyNot").on("click", ".FancyNot", function (e) {
        clearInterval(myVar1);
        clearInterval(myVar2);
        var id = $(this).attr('NotId');

        console.log("id=" + id + ", Session=" + $("#Session" + id).val() + ", NRun=" + $("#NRun" + id).val() + ", YRun=" + $("#YRun" + id).val() + ", Min=" + $("#Min" + id).val() + ", Max=" + $("#Max" + id).val());

        if ($("#NRun" + id).val() == "0.00" || $("#NRun" + id).val() == "0")
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: "No Any Rate Were Found For Placing Bet.",
                showConfirmButton: true
            });
        else {
            $("#DisplayBhavType" + id).val("Session");

            $("#myModalLabel").html('<strong><div><div class="h6 p-0 m-0">' + $("#Session" + id).val() + '</div></div></strong>');

            $("#Rate_Odds").html("Run");
            $("#Mode_Odds").html("Mode");

            $("#Rate2_Odds").html("Not");

            $("#SessionBetChk").val("1");
            $("#SessionName").val($("#Session" + id).val());
            $("#SessionRun").val($("#NRun" + id).val());
            $("#SessionRate").val($("#NRate" + id).val());
            $("#SessionYN").val("NO");

            $("#SessionNRun").val($("#NRun" + id).val());
            $("#SessionNRate").val($("#NRate" + id).val());
            $("#SessionYRun").val($("#YRun" + id).val());
            $("#SessionYRate").val($("#YRate" + id).val());
            $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

            $("#MBetType").val("Fancy_Odds");

            //console.log($("#Team"+id).val()+", "+$("#KRate"+id).val())
            //console.log("key="+key+", SessionMinAmount="+$scope.Fbhavdata[key].Min+", SessionMaxAmount="+$scope.Fbhavdata[key].Max);
            document.getElementById("SessionMinAmount_Session").value = $("#Min" + id).val();
            document.getElementById("SessionMaxAmount_Session").value = $("#Max" + id).val();

            document.getElementById("AmountTimeChk").value = "Yes";
            //document.getElementById("AmountTime").className = "AmountTime";

            //$("#Timer").show();
            $("#Timer").css('display', 'none');
            var $window = $(window);
            var windowsize = $window.width();
            //console.log(windowsize);
            if (windowsize >= 500) {
                $("#betSlipBoxSession").css('display', 'block');
                $("#DisplayBhavName").html($("#Session" + id).val());
                $("#Rate1_Odds").val($("#NRun" + id).val());
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("cmdDone").style.visibility = "visible";
                document.getElementById("MatchAmount").value = "";
                document.getElementById("MatchAmount").readOnly = false;
                $("#betBoxColor").css('background-color', 'rgb(250, 169, 186)');
            } else {
                $("#betSlipBoxSessionMob").css('display', 'block');
                $("#DisplayBhavNameMob").html($("#Session" + id).val());
                $("#Rate1_OddsMob").val($("#NRun" + id).val());
                document.getElementById("cmdDoneMob").disabled = false;
                document.getElementById("cmdDoneMob").style.visibility = "visible";
                document.getElementById("MatchAmountMob").value = "";
                document.getElementById("MatchAmountMob").readOnly = false;
                $("#betBoxColorMob").css('background-color', 'rgb(250, 169, 186)');
            }

            //$("#PlaceBet").modal("show");
            console.log("in");
            //document.BetPlayer.AmountTime.value="8";
            $("#AmountTime").html(matchSettings.BTS);
            $("#AmountTimeMob").html(matchSettings.BTS);
            console.log("BTS=" + matchSettings.BTS);
            document.getElementById("MatchAmount").focus();
            myVar1 = setInterval(function () { AmountTimeMatch() }, 1000);

        }
    });

    $(document).off("click", ".FancyYes").on("click", ".FancyYes", function (e) {
        clearInterval(myVar1);
        clearInterval(myVar2);
        var id = $(this).attr('YesId');

        console.log("id=" + id + ", Session=" + $("#Session" + id).val() + ", NRun=" + $("#NRun" + id).val() + ", YRun=" + $("#YRun" + id).val() + ", Min=" + $("#Min" + id).val() + ", Max=" + $("#Max" + id).val());

        if ($("#YRun" + id).val() == "0.00" || $("#YRun" + id).val() == "0")
            Swal.fire({
                position: 'top-end',
                icon: 'error',
                title: "No Any Rate Were Found For Placing Bet.",
                showConfirmButton: true
            });
        else {
            $("#DisplayBhavType" + id).val("Session");
            $("#myModalLabel").html('<strong><div><div class="h6 p-0 m-0">' + $("#Session" + id).val() + '</div></div></strong>');

            $("#Rate_Odds").html("Run");
            $("#Mode_Odds").html("Mode");

            $("#Rate2_Odds").html("Yes");

            $("#SessionBetChk").val("1");
            $("#SessionName").val($("#Session" + id).val());
            $("#SessionRun").val($("#YRun" + id).val());
            $("#SessionRate").val($("#YRate" + id).val());
            $("#SessionYN").val("Yes");

            $("#SessionNRun").val($("#NRun" + id).val());
            $("#SessionNRate").val($("#NRate" + id).val());
            $("#SessionYRun").val($("#YRun" + id).val());
            $("#SessionYRate").val($("#YRate" + id).val());
            $("#ServerTime_Select").val($("#ServerTime_Formatted").val());

            //console.log($("#Team"+id).val()+", "+$("#KRate"+id).val())

            $("#MBetType").val("Fancy_Odds");

            document.getElementById("SessionMinAmount_Session").value = $("#Min" + id).val();
            document.getElementById("SessionMaxAmount_Session").value = $("#Max" + id).val();

            document.getElementById("AmountTimeChk").value = "Yes";
            //document.getElementById("AmountTime").className = "AmountTime";

            //$("#Timer").show();
            $("#Timer").css('display', 'none');
            var $window = $(window);
            var windowsize = $window.width();
            //console.log(windowsize);
            if (windowsize >= 500) {
                $("#betSlipBoxSession").css('display', 'block');
                $("#DisplayBhavName").html($("#Session" + id).val());
                $("#Rate1_Odds").val($("#YRun" + id).val());
                document.getElementById("cmdDone").disabled = false;
                document.getElementById("cmdDone").style.visibility = "visible";
                document.getElementById("MatchAmount").value = "";
                document.getElementById("MatchAmount").readOnly = false;
                $("#betBoxColor").css('background-color', 'rgb(114, 187, 239)');
            } else {
                $("#betSlipBoxSessionMob").css('display', 'block');
                $("#DisplayBhavNameMob").html($("#Session" + id).val());
                $("#Rate1_OddsMob").val($("#YRun" + id).val());
                document.getElementById("cmdDoneMob").disabled = false;
                document.getElementById("cmdDoneMob").style.visibility = "visible";
                document.getElementById("MatchAmountMob").value = "";
                document.getElementById("MatchAmountMob").readOnly = false;
                $("#betBoxColorMob").css('background-color', 'rgb(114, 187, 239)');
            }

            //$("#PlaceBet").modal("show");
            console.log("in");
            //document.BetPlayer.AmountTime.value="8";
            $("#AmountTime").html(matchSettings.BTS);
            $("#AmountTimeMob").html(matchSettings.BTS);
            console.log("BTS=" + matchSettings.BTS);
            document.getElementById("MatchAmount").focus();
            myVar1 = setInterval(function () { AmountTimeMatch() }, 1000);

        }
    });

    function AmountTimeMatch() {
        $("#AmountTime").html(parseInt($("#AmountTime").html()) - 1);
        $("#AmountTimeMob").html(parseInt($("#AmountTimeMob").html()) - 1);
        //document.getElementById("AmountTime").innerHTML=document.getElementById("AmountTime").value;

        if ($("#AmountTime").html() == "") {
            clearInterval(myVar1);
        }

        console.log("AmountTimeMatch, AmountTime='" + $("#AmountTime").html() + "'");

        if (parseInt($("#AmountTime").html()) == 0) {
            //clearInterval(myVar1);
            // document.getElementById("MatchAmount").value = "";
            // console.log("MatchAmount Cleared");
            document.getElementById("MatchAmount").readOnly = true;
            document.getElementById("cmdDone").disabled = true;
            $("#cmdDone").css('visibility', 'hidden');
            $("#betSlipBoxSession").css('display', 'none');
            $("#betSlipBoxSessionMob").css('display', 'none');

            //document.getElementById("AmountTime").value="";
            document.getElementById("MatchBetChk").value = "";
            document.getElementById("SessionBetChk").value = "";
            document.getElementById("AmountTimeChk").value = "No";
        }
        else if (parseInt($("#AmountTime").html()) <= -1) {
            clearInterval(myVar1);
            $("#AmountTime").html("");
            $("#AmountTimeMob").html("");
            document.getElementById("cmdDone").disabled = true;
            $("#cmdDone").css('visibility', 'hidden');
            $("#betSlipBoxSession").css('display', 'none');
            $("#betSlipBoxSessionMob").css('display', 'none');
            HidePlaceBet();
        }
        else if (parseInt($("#AmountTime").html()) <= 6) {
            document.getElementById("cmdDone").disabled = false;
        } else if (Number.isNaN(parseInt($("#AmountTime").html()))) {
            clearInterval(myVar1);
        }
    }

    function AmountTimeSession() {
        // document.getElementById("AmountTime").value=document.getElementById("AmountTime").value-1;
        // document.getElementById("AmountTime").innerHTML=document.getElementById("AmountTime").value;
        $("#AmountTime").html(parseInt($("#AmountTime").html()) - 1);
        $("#AmountTimeMob").html(parseInt($("#AmountTimeMob").html()) - 1);
        if (parseInt($("#AmountTime").html()) == 0) {
            //clearInterval(myVar1);
            document.getElementById("MatchAmount").value = "";
            document.getElementById("MatchAmount").readOnly = true;
            document.getElementById("cmdDone").disabled = true;
            $("#cmdDone").css('visibility', 'hidden');
            HidePlaceBet();
            //document.getElementById("AmountTime").value="";
            document.BetPlayer.MatchBetChk.value = "";
            document.BetPlayer.SessionBetChk.value = "";
            document.BetPlayer.AmountTimeChk.value = "No";
        }
        else if (parseInt($("#AmountTime").html()) == "-1") {
            clearInterval(myVar1);
            document.getElementById("AmountTime").value = "";
            document.getElementById("cmdDone").disabled = true;
            $("#cmdDone").css('visibility', 'hidden');
            HidePlaceBet();
        }
        else if (document.getElementById("AmountTime").value <= 6) {
            document.getElementById("cmdDone").disabled = false;
        }
    }

    function HidePlaceBet() {

        console.log("HidePlaceBet");

        $("#betSlipBoxSession").css('display', 'none');
        $("#betSlipBoxSessionMob").css('display', 'none');
        console.log("hide");
        document.getElementById("cmdDone").disabled = true;

        clearInterval(myVar1);

        $("#AmountTime").html("");
        $("#AmountTimeMob").html("");
        //document.getElementById("AmountTime").value="";
        //document.getElementById("MatchAmount").value = "";

        //document.getElementById("AmountTime").className = "AmountTime";

    }

    function SubmitBet() {

        clearInterval(myVar1);

        console.log("clearInterval myVar1" + ", MatchAmount=" + document.getElementById("MatchAmount").value);
        console.log("MBetType=" + $("#MBetType").val());

        // Set server time submit value
        $("#ServerTime_Submit").val($("#ServerTime_Formatted").val());

        console.log("MBetType=" + $("#MBetType").val());
        if (matchSettings.PTM === 0 || matchSettings.PTS === 0) {
            PlaceBet();
        } else {
            if ($("#MBetType").val() === "Fancy_Odds") {
                SubmitSessionBet();
            } else {
                SubmitMatchBet();
            }
        }
    }

    function SubmitMatchBet() {

        console.log("SubmitMatchBet");

        $("#MatchAmount").prop("readonly", true);
        const windowSize = window.innerWidth;

        if (windowSize >= 500) {
            $("#cmdDone").prop("disabled", true);
        } else {
            $("#cmdDoneMob").prop("disabled", true);
        }

        clearInterval(myVar1);

        console.log("PTBM=" + matchSettings.PTBM);

        $("#AmountTime").html(matchSettings.PTBM);
        $("#AmountTimeMob").html(matchSettings.PTBM);

        myVar2 = setInterval(SubmitTime, 1000);
    }

    // Function for submitting session bet
    function SubmitSessionBet() {

        console.log("SubmitSessionBet");

        $("#MatchAmount").prop("readonly", true);
        const windowSize = window.innerWidth;

        if (windowSize >= 500) {
            $("#cmdDone").prop("disabled", true);
        } else {
            $("#cmdDoneMob").prop("disabled", true);
        }

        clearInterval(myVar1);

        console.log("PTS=" + matchSettings.PTS);

        $("#AmountTime").html(matchSettings.PTS);
        $("#AmountTimeMob").html(matchSettings.PTS);

        myVar2 = setInterval(SubmitTime, 1000);

    }

    // Function for updating the time
    function SubmitTime() {

        console.log("SubmitTime");

        if ($("#AmountTime").html() == "" || $("#AmountTime").html() == 0) {
            clearInterval(myVar1);
        }

        console.log("SubmitTime, AmountTime='" + $("#AmountTime").html() + "'");

        // if (Number.isNaN(parseInt($("#AmountTime").html())))
        //     $("#AmountTime").html("");
        // else {
        $("#AmountTime").html(parseInt($("#AmountTime").html()) - 1);
        $("#AmountTimeMob").html(parseInt($("#AmountTimeMob").html()) - 1);
        //}

        if (parseInt($("#AmountTime").html()) <= 0 || $("#AmountTime").html() == "") {
            clearInterval(myVar2);
            PlaceBet();
        }
    }

    function PlaceBet() {
        console.log("MBetType=" + $("#MBetType").val());

        if ($("#MBetType").val() === "Fancy_Odds") {
            PlaceSessionBet();
        } else {
            PlaceMatchBet();
        }
    }

    function PlaceMatchBet() {

        console.log("PlaceMatchBet");

        document.getElementById("cmdDone").disabled = true;

        var windowSize = window.innerWidth;
        var BetAmount = 0;

        console.log("windowSize=" + windowSize);

        // Set BetAmount based on window size
        if (windowSize >= 500) {
            BetAmount = ($("#MatchAmount").val());
        } else {
            BetAmount = ($("#MatchAmountMob").val());
        }

        console.log("BetAmount=" + BetAmount);

        const windowWidth = window.innerWidth;
        let betAmount = windowWidth >= 500
            ? parseFloat(document.getElementById("MatchAmount").value)
            : parseFloat(document.getElementById("MatchAmountMob").value);

        console.log("betAmount=" + betAmount);

        var Response = "";
        var MatchMinAmount = 0;
        var MatchMaxAmount = 0;
        var NotificationType = "";
        var UserType = document.getElementById("UserType").value;
        var UserName = document.getElementById("UserName").value;

        if ($("#MBetType").val() == "Match_Odds") {
            MatchMinAmount = $("#MatchMinAmount").val();//$scope.MatchMinAmount;
            MatchMaxAmount = $("#MatchMaxAmount").val();//$scope.MatchMaxAmount;
            NotificationType = "Match Bet";
        } else {
            MatchMinAmount = $("#BookMakerMinAmount").val();//$scope.BookMakerMinAmount;
            MatchMaxAmount = $("#BookMakerMaxAmount").val();//$scope.BookMakerMaxAmount;
            NotificationType = "Book Maker Bet";
        }

        if (isNaN(BetAmount)) {
            Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div data-reactroot="" class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p style="font-size:14px;">Invalid Amount ${BetAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = Response;
            setTimeout(function () {
                document.getElementById("BetResponse").innerHTML = "";
            }, 3000);
            return;
        }

        console.log("BetAmount=" + BetAmount + ", MatchMinAmount=" + MatchMinAmount + ", MatchMaxAmount=" + MatchMaxAmount);

        if (parseFloat(BetAmount) >= parseFloat(MatchMinAmount) && parseFloat(BetAmount) <= parseFloat(MatchMaxAmount)) {


            var BetRate = document.getElementById("MatchRate").value;
            var BetMode = document.getElementById("MatchBetChk").value;
            var BetTeam = document.getElementById("MatchTeam").value;
            var MatchCode = document.getElementById("MatchCode").value;
            var MatchBetChk = document.getElementById("MatchBetChk").value;
            var MatchType = document.getElementById("MatchType").value;
            var UserType = document.getElementById("UserType").value;
            var UserName = document.getElementById("UserName").value;
            var TeamKRate = document.getElementById("TeamKRate").value;
            var TeamLRate = document.getElementById("TeamLRate").value;
            var BST = document.getElementById("ServerTime_Select").value;
            var BPT = document.getElementById("ServerTime_Submit").value;
            var id = document.getElementById("BetTeamindex").value;

            //if (document.getElementById("TeamKRate").value == document.getElementById("KRate_BM" + id).value || document.getElementById("TeamLRate").value == document.getElementById("LRate_BM" + id).value) {

            var url = `${API_DOMAIN}/PlaceMatchBetNew.php`; // Replace with your URL for the request

            console.log(url);

            // Clear interval
            clearInterval(myVar1);
            clearInterval(myVar2);
            document.getElementById("AmountTime").innerHTML = "0";

            // Prepare data for the request
            var data = {
                BetRate: BetRate,
                BetAmount: BetAmount,
                BetMode: BetMode,
                BetTeam: BetTeam,
                MatchCode: MatchCode,
                MatchBetChk: MatchBetChk,
                MatchType: MatchType,
                BetType: $("#MBetType").val(),
                TeamKRate: TeamKRate,
                TeamLRate: TeamLRate,
                BST: BST,
                BPT: BPT,
                ut: UserType,
                un: UserName
            };

            // Make the POST request using fetch
            fetch(url, {
                method: "POST",
                credentials: 'include',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            })
                .then(response => response.json())
                .then(res => {
                    if (res.Status === "Success") {
                        // Update coins display
                        document.getElementById("TotalCoins").innerHTML = res.TotalCoins - res.UsedCoins;
                        document.getElementById("UsedCoins").innerHTML = res.UsedCoins;
                        //document.getElementById("RCoins").innerHTML = res.RemCoins;

                        document.getElementById("TotalCoinsMob").innerHTML = res.TotalCoins - res.UsedCoins;
                        document.getElementById("UsedCoinsMob").innerHTML = res.UsedCoins;

                        sessionStorage.setItem('Coins', res.TotalCoins);
                        sessionStorage.setItem('Exposure', res.UsedCoins);

                        //document.getElementById("RCoinsMob").innerHTML = res.RemCoins;

                        setMatchBets((prevBets) => [res.BetDetails[0], ...prevBets]);

                        // Update team amounts
                        TeamPM[0] = res.Team1Amt;
                        TeamPM[1] = res.Team2Amt;
                        TeamPM[2] = res.Team3Amt;

                        setAllTeamPM({
                            Team1PM: res.Team1Amt,
                            Team2PM: res.Team2Amt,
                            Team3PM: res.Team3Amt,
                        });

                        console.log(TeamPM);
                        console.log("Team1Amt=" + allTeamPM.Team1PM);

                        //cons
                        // Display bet information
                        document.getElementById("betSlipBoxSession").style.display = 'none';
                        document.getElementById("betSlipBoxSessionMob").style.display = 'none';

                        Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                    <div data-reactroot="" class="message-content success">
                                        <i class="component-icon-wrap icon-success"></i>
                                        <p style="font-size:14px;">Bet Successful</p>
                                    </div>
                                </div>`;
                    } else if (res.LogoutStat === "Yes") {
                        window.location = '/';
                        //console.log(res.Message);
                        sessionStorage.setItem("LogoutMsg", res.Message);
                    } else {
                        Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                                    <div data-reactroot="" class="message-content error">
                                        <i class="component-icon-wrap icon-error"></i>
                                        <p style="font-size:14px;">${res.Message}</p>
                                    </div>
                                </div>`;
                    }

                    document.getElementById("BetResponse").innerHTML = Response;
                    document.getElementById("betSlipBoxSession").style.display = 'none';
                    document.getElementById("betSlipBoxSessionMob").style.display = 'none';

                    setTimeout(function () {
                        document.getElementById("BetResponse").innerHTML = "";
                    }, 3000);
                })
                .catch(error => {
                    console.error("Error during the request:", error);
                });

            // } else {
            //     Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
            //                 <div data-reactroot="" class="message-content error">
            //                     <i class="component-icon-wrap icon-error"></i>
            //                     <p style="font-size:14px;">Bet Rejected. Rate Has Been Changed</p>
            //                 </div>
            //             </div>`;
            //     document.getElementById("BetResponse").innerHTML = Response;
            //     document.getElementById("betSlipBoxSession").style.display = 'none';
            //     document.getElementById("betSlipBoxSessionMob").style.display = 'none';
            //     setTimeout(function () {
            //         document.getElementById("BetResponse").innerHTML = "";
            //     }, 3000);
            // }

        } else if (parseFloat(BetAmount) < parseFloat(MatchMinAmount)) {
            Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div data-reactroot="" class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p style="font-size:14px;">Minimum Bet Amount is ${MatchMinAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = Response;
            setTimeout(function () {
                document.getElementById("BetResponse").innerHTML = "";
            }, 3000);

        } else if (parseFloat(BetAmount) > parseFloat(MatchMaxAmount)) {
            Response = `<div class="component-message-wrap" style="animation-duration: 3000ms">
                        <div data-reactroot="" class="message-content error">
                            <i class="component-icon-wrap icon-error"></i>
                            <p style="font-size:14px;">Maximum Bet Amount is ${MatchMaxAmount}</p>
                        </div>
                    </div>`;
            document.getElementById("BetResponse").innerHTML = Response;
            setTimeout(function () {
                document.getElementById("BetResponse").innerHTML = "";
            }, 3000);
        }

        console.log(Response);

    }

    function PlaceSessionBet() {
        // Disable the button once clicked
        document.getElementById("cmdDone").disabled = true;

        // Get values for min and max bet amounts
        let SessionMinAmount = parseFloat(document.getElementById("SessionMinAmount_Session").value);
        let SessionMaxAmount = parseFloat(document.getElementById("SessionMaxAmount_Session").value);
        let Response = "";

        // Get window size
        let windowsize = window.innerWidth;
        let BetAmount = 0;

        if (windowsize >= 500) {
            BetAmount = parseFloat(document.getElementById("MatchAmount").value);
        } else {
            BetAmount = parseFloat(document.getElementById("MatchAmountMob").value);
        }

        // Validate BetAmount
        if (!isNaN(BetAmount)) {
            if (BetAmount >= SessionMinAmount && BetAmount <= SessionMaxAmount) {
                // Retrieve other form values
                let BetRate = document.getElementById("SessionRate").value;
                let BetMode = document.getElementById("SessionYN").value;
                let BetRun = document.getElementById("SessionRun").value;
                let SessionName = document.getElementById("SessionName").value;
                let MatchCode = document.getElementById("MatchCode").value;
                let SessionBetChk = document.getElementById("SessionBetChk").value;
                let SessionYN = document.getElementById("SessionYN").value;
                let UserType = document.getElementById("UserType").value;
                let UserName = document.getElementById("UserName").value;

                let SessionNRun = document.getElementById("SessionNRun").value;
                let SessionNRate = document.getElementById("SessionNRate").value;
                let SessionYRun = document.getElementById("SessionYRun").value;
                let SessionYRate = document.getElementById("SessionYRate").value;
                let BST = document.getElementById("ServerTime_Select").value;
                let BPT = document.getElementById("ServerTime_Submit").value;

                // Construct the URL for the request
                let url = `${API_DOMAIN}/PlaceSessionBet.php?BetRate=${BetRate}&BetAmount=${BetAmount}&BetRun=${BetRun}&BetMode=${BetMode}&SessionName=${SessionName}&MatchCode=${MatchCode}&SessionBetChk=${SessionBetChk}&SessionYN=${SessionYN}&SessionNRun=${SessionNRun}&SessionNRate=${SessionNRate}&SessionYRun=${SessionYRun}&SessionYRate=${SessionYRate}&BST=${BST}&BPT=${BPT}&ut=${UserType}&un=${UserName}`;

                // Clear any ongoing interval and reset some HTML elements
                clearInterval(myVar1);
                document.getElementById("AmountTime").innerHTML = "0";
                document.getElementById("AmountTimeMob").innerHTML = "0";
                //document.getElementById("Timer").style.display = "block";

                // Make the POST request
                fetch(url, {
                    method: "POST",
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        BetRate: BetRate,
                        BetAmount: BetAmount,
                        BetRun: BetRun,
                        BetMode: BetMode,
                        SessionName: SessionName,
                        MatchCode: MatchCode,
                        SessionBetChk: SessionBetChk,
                        SessionYN: SessionYN,
                        SessionNRun: SessionNRun,
                        SessionNRate: SessionNRate,
                        SessionYRun: SessionYRun,
                        SessionYRate: SessionYRate,
                        BST: BST,
                        BPT: BPT,
                        ut: UserType,
                        un: UserName
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        document.getElementById("cmdDone").disabled = true;

                        // Clear the bet form
                        //document.getElementById("ClientBitMultiChk").value = "";

                        clearInterval(myVar1);
                        clearInterval(myVar2);

                        document.getElementById("AmountTime").innerHTML = "0";
                        document.getElementById("AmountTimeMob").innerHTML = "0";
                        document.getElementById("MatchAmount").value = "";

                        // Reset the session fields
                        document.getElementById("SessionNRun").value = "";
                        document.getElementById("SessionNRate").value = "";
                        document.getElementById("SessionYRun").value = "";
                        document.getElementById("SessionYRate").value = "";
                        document.getElementById("ServerTime_Select").value = "";
                        document.getElementById("ServerTime_Submit").value = "";

                        let Response = "";
                        if (data.Status === "Success") {
                            // Update UI with success message and new bet details
                            // Assuming FancyBets is an array and FancyBetShow is a flag to show the bets
                            //FancyBets.unshift(data.BetDetails[0]);
                            //FancyBetShow = true;
                            //DisplayBets('All');

                            setSessionBets((prevBets) => [data.BetDetails[0], ...prevBets]);

                            document.getElementById("betSlipBoxSession").style.display = 'none';
                            document.getElementById("betSlipBoxSessionMob").style.display = 'none';

                            // Update coins UI
                            document.getElementById("TotalCoins").innerHTML = data.TotalCoins - data.UsedCoins;
                            document.getElementById("UsedCoins").innerHTML = data.UsedCoins;
                            //document.getElementById("RCoins").innerHTML = data.RemCoins;

                            document.getElementById("TotalCoinsMob").innerHTML = data.TotalCoins - data.UsedCoins;
                            document.getElementById("UsedCoinsMob").innerHTML = data.UsedCoins;
                            //document.getElementById("RCoinsMob").innerHTML = data.RemCoins;

                            sessionStorage.setItem('Coins', data.TotalCoins);
                            sessionStorage.setItem('Exposure', data.UsedCoins);

                            // Display success message
                            Response = '<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content success"><i class="component-icon-wrap icon-success"></i><p>Bet Successful</p></div></div>';
                        } else if (data.LogoutStat == "Yes") {
                            window.location = '/';
                        } else {
                            Response = `<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>${data.Message}</p></div></div>`;
                        }

                        // Show response
                        document.getElementById("BetResponse").innerHTML = Response;
                        document.getElementById("betSlipBoxSession").style.display = 'none';
                        document.getElementById("betSlipBoxSessionMob").style.display = 'none';

                        setTimeout(function () {
                            document.getElementById("BetResponse").innerHTML = "";
                        }, 3000);
                    })
                    .catch(error => {
                        console.error("Error with the request:", error);
                    });
            } else {
                // Bet amount is outside of the valid range
                if (BetAmount < SessionMinAmount) {
                    Response = `<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>Minimum Bet Amount is ${SessionMinAmount}</p></div></div>`;
                } else if (BetAmount > SessionMaxAmount) {
                    Response = `<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>Maximum Bet Amount is ${SessionMaxAmount}</p></div></div>`;
                }

                document.getElementById("BetResponse").innerHTML = Response;
                setTimeout(function () {
                    document.getElementById("BetResponse").innerHTML = "";
                }, 3000);
            }
        } else {
            Response = `<div class="component-message-wrap" style="animation-duration: 3000ms"><div class="message-content error"><i class="component-icon-wrap icon-error"></i><p>Invalid Amount ${BetAmount}</p></div></div>`;
            document.getElementById("BetResponse").innerHTML = Response;
            setTimeout(function () {
                document.getElementById("BetResponse").innerHTML = "";
            }, 3000);
        }
    }

    function ShowHideLiveTV(MatchId) {
        console.log($("#videos").css("display"));
        if ($("#videos").css("display") == "none") {
            $("#lnkLiveTV").html("Hide TV");
            $("#LiveTVDiv1").css("display", "block");
            $("#videos").css("display", "block");
            $("#videos").attr("src", `https://mis3.sqmr.xyz/rtv.php?eventId=${MatchId}`);
        } else {
            $("#lnkLiveTV").html("Live TV");
            $("#LiveTVDiv1").css("display", "none");
            $("#videos").css("display", "none");
            $("#videos").attr("src", "");
        }
    }

    useEffect(() => {

        setscoreSrc("");
        setliveTVSrc("");
        setMatchSettings("{}");

        setUserType(sessionStorage.getItem("UserType"));
        setUserName(sessionStorage.getItem("UserName"));

        const param1 = sessionStorage.getItem("UserType");
        const param2 = sessionStorage.getItem("UserName");

        const params = { ut: param1, un: param2, mc: MatchCode };

        const queryString = new URLSearchParams(params).toString();
        const url = `${API_DOMAIN}/api/Client/getMatchDetails.php?${queryString}`;

        const fetchMatchSettings = async () => {
            try {
                //const url = 'your_api_endpoint_here';
                const response = await fetch(url, {
                    method: 'GET',
                    credentials: 'include', // Equivalent to withCredentials: true
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                const data = await response.json();

                if (data.Status === 'Error') {
                    window.location = '/';
                    return;
                }

                // Use a local variable to immediately access fetched data
                const fetchedSettings = data.data[0];

                setMatchSettings(fetchedSettings);
                setliveTVSrc(fetchedSettings.LiveTVURL1);
                setscoreID(fetchedSettings.ScoreID);

                LiveTVURL = fetchedSettings.LiveTVURL;
                setscoreSrc(fetchedSettings.ScoreURL1);

                SessionMinAmount = fetchedSettings.SessionMinAmount;
                SessionMaxAmount = fetchedSettings.SessionMaxAmount;
                Team1 = fetchedSettings.Team1;
                Team2 = fetchedSettings.Team2;
                Team3 = fetchedSettings.Team3;

                /* ===== ADDED LOGIC FOR Team1PM to Team10PM ===== */

                const updatedPM = {
                    Team1PM: fetchedSettings.Team1PM ?? 0,
                    Team2PM: fetchedSettings.Team2PM ?? 0,
                    Team3PM: fetchedSettings.Team3PM ?? 0,
                    Team4PM: fetchedSettings.Team4PM ?? 0,
                    Team5PM: fetchedSettings.Team5PM ?? 0,
                    Team6PM: fetchedSettings.Team6PM ?? 0,
                    Team7PM: fetchedSettings.Team7PM ?? 0,
                    Team8PM: fetchedSettings.Team8PM ?? 0,
                    Team9PM: fetchedSettings.Team9PM ?? 0,
                    Team10PM: fetchedSettings.Team10PM ?? 0,
                };

                setAllTeamPM(updatedPM);

                /* ===== END OF ADDED LOGIC ===== */

                $("#divMatchBhav").css("display", "block");

                setLoading(false); // Set loading to false

            } catch (err) {
                console.error('Error fetching data:', err);
                setError(err); // Save any error to the state
                setLoading(false);
            }
        };

        fetchMatchSettings();

        const queryStringMSBets = new URLSearchParams(params).toString();
        const urlMSBets = `${API_DOMAIN}/api/Client/getMatchSessionBetsByClient.php?${queryStringMSBets}`;

        //console.log(urlMSBets);

        fetch(urlMSBets, {
            method: 'GET',
            credentials: 'include', // Equivalent to withCredentials:true
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.Status == "Error") {
                    sessionStorage.setItem("LogoutMsg", data.Message)
                    window.location = '/';
                } else {
                    //console.log("Session_Bets="+data[1].Fancy_Bets);
                    setMatchBets(data[0].Match_Bets);
                    setSessionBets(data[1].Fancy_Bets);

                    if (data[2].Match_PM.length > 0) {
                        // console.log(data[2].Match_PM[0].Team1PM);
                        // console.log(data[2].Match_PM[0].Team2PM);
                        // console.log(data[2].Match_PM[0].Team3PM);
                        updateValues(100, 200);
                        setAllTeamPM({
                            Team1PM: data[2].Match_PM[0].Team1PM,
                            Team2PM: data[2].Match_PM[0].Team2PM,
                            Team3PM: data[2].Match_PM[0].Team3PM,
                        });

                        const updatedTeamPM = [
                            data[2].Match_PM[0].Team1PM,
                            data[2].Match_PM[0].Team2PM,
                            data[2].Match_PM[0].Team3PM,
                        ];
                        setTeamPM(updatedTeamPM);

                        // setTeamPM((prevTeamPM) => {
                        //     const updatedTeamPM = [...prevTeamPM]; // Create a shallow copy
                        //     updatedTeamPM[0] = "100"; // Update index 0
                        //     updatedTeamPM[1] = "200"; // Update index 1
                        //     updatedTeamPM[1] = "300"; // Update index 1
                        //     return updatedTeamPM; // Return the updated array
                        // });
                        // updateTeamPM(0,data[0].Match_Bets[0].Team1PM);
                        // updateTeamPM(1,data[0].Match_Bets[0].Team2PM);
                        // updateTeamPM(2,data[0].Match_Bets[0].Team3PM);

                        TeamPM[0] = data[2].Match_PM[0].Team1PM;
                        TeamPM[1] = data[2].Match_PM[0].Team2PM;
                        TeamPM[2] = data[2].Match_PM[0].Team3PM;

                        // console.log("updatedTeamPM=" + updatedTeamPM);
                        // console.log("teamPM=" + teamPM);
                        // console.log("TeamPM=" + TeamPM);
                        // console.log("allTeamPM.Team1PM=" + allTeamPM.Team1PM);
                    }
                    //console.log(SessionBets);
                }
                setLoading(false); // Set loading to false
            })
            .catch(err => {
                setError(err); // Save any error to the state
                setLoading(false); // Set loading to false
                //console.log("err="+err);
            });

        const handleLoad = () => {
            setIsLoaded(true);
            console.log("isLoaded=" + isLoaded);
        };

        // Attach the event listener for window load
        window.addEventListener("load", handleLoad);

        const marketOdsCall = setInterval(() => {
            if ($("#socketConnected").val() == 0) {
                $("#apiCallingMethod").html("A");
                getBhavData(4236);
            }
        }, 1000);
        
        window.connectOddsWebsocket(MatchCode, onMessageRecieveCallback)
        
        return () => {
            clearInterval(marketOdsCall);
            clearInterval(myVar2); clearInterval(myVar1);
            window.disconnectOddsWebsocket();
        }

    }, []);  // Empty dependency array ensures this runs only once when the component mounts

    const onMessageRecieveCallback = (data) => {
        //console.log('============================', data);
        getBhavData_Socket(JSON.parse(data));
    }

    // if (loading) return <p>Loading...</p>;
    // if (error) return <p>Error: {error.message}</p>;

    const styles = {
        scoreMain: {
            justifyContent: 'space-around',
            padding: 0,
            textAlign: 'center',
        },
        teamName: {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '100%',
            color: '#ff911f',
        },
        teamScore: {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '100%',
            color: '#e9d126',
        },
        teamOver: {
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '100%',
            color: '#9fa3a7',
        },
        teamCrr: {
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '10px',
            lineHeight: '100%',
            color: '#9fa3a7',
        },
        teamMessageBlock: {
            background: '#000',
            padding: '8px',
            height: '55px',
            borderRadius: '15px',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        teamMessage: {
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '19px',
            lineHeight: '100%',
            color: '#e8ff26',
        },
        lastOvers: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            color: '#9fa3a7',
        },
        ball: {
            width: '14px',
            height: '14px',
            background: '#131e29',
            borderRadius: '50%',
            marginLeft: '0.75em',
            display: 'flex',
            padding: '1.25em',
            justifyContent: 'center',
            alignItems: 'center',
            fontStyle: 'normal',
            fontWeight: 700,
            fontSize: '11px',
            lineHeight: '12px',
            color: '#cfd1d3',
            border: '1px solid #1e2833',
            boxShadow: '0 1px 2px 0 rgb(0 0 0 / 10%)',
        },
        four: {
            background: '#6c9ce6',
            border: '1px solid #6c9ce6',
        },
        six: {
            background: '#418019',
            border: '1px solid #418019',
        },
        wicket: {
            background: 'red',
            border: '1px solid #aa0707',
        },
        bgMain: {
            height: '100%',
            width: '100%',
            minHeight: '215px',
        },
        lastWicketBlock: {
            background: '#1a242e',
            padding: '10px 0',
        },
    };

    return (
        <>

            <section className="match-content">
                <div>
                    <div>
                        <div className="match-box">
                            <div className="mod-header mod-header2">
                                <div className="select-tv-ico">
                                    <span className="badge badge-warning">
                                        <Link to="/Dashboard" style={{ textDecoration: 'none', color: 'black' }}>
                                            Back
                                        </Link>
                                    </span>
                                    <div style={{ float: 'right' }}>
                                        <time>
                                            <img src="/assets/images/live-tv.png" />
                                        </time>
                                        <span id="lnkLiveTV" onClick={() => ShowHideLiveTV(MatchID)}>Live Tv</span>
                                    </div>
                                </div>
                            </div>
                            <div className="collapse"></div>
                        </div>
                        <div style={{ fontSize: '12px', backgroundColor: 'black' }} id="LiveTVDiv1">
                            {/* <iframe id="videos" src={`${liveTVSrc}`} height="250" style={{ display: 'none', backgroundColor: 'black' }} ></iframe> */}
                            <iframe id="videos" src="" height="250" style={{ display: 'none', backgroundColor: 'black' }} ></iframe>
                        </div>

                        {!LiveTVURL ? (
                            <div style={{ margin: '0px', padding: '0px', backgroundColor: '#252328', height: '170px' }}>
                                {/* <div className="row scoremain" style={{ color: '#fff' }}>
                                    <div className="col-2 col-md-2">
                                        <span className="">
                                            <img alt="team image" width="50px" height="35px" src='{`https://images.weserv.nl/?url=${Sbhavdata[0].Team1Flag}`' />
                                        </span>
                                    </div>
                                    <div className="col-8 col-md-8">
                                        <span className="" style={{ fontSize: '12px' }} ng-bind="Sbhavdata[0].ScoreStatus"></span>
                                    </div>
                                    <div className="col-2 col-md-2">
                                        <span className="">
                                            <img alt="team image" width="50px" height="35px" src='{`https://images.weserv.nl/?url=${Sbhavdata[0].Team2Flag}`' />
                                        </span>
                                    </div>
                                    <div className="col-4 col-md-4" style={{ textAlign: 'left', paddingLeft: '20px' }}>
                                        <span className="team-name" ng-bind={Sbhavdata[0].Team1Name_Short}> SYT</span>
                                        <br></br>
                                        <span className="team-score" ng-bind={Sbhavdata[0].Team1OnlyScore}>200-7</span>
                                        <span className="team-crr"></span>
                                    </div>

                                    <div>
                                        <div className="col-4 col-md-4 team-message-block">
                                            <span className="team-message">{Sbhavdata[0].LiveCommentary}</span>
                                        </div>
                                        <div className="col-4 col-md-4" style={{ textAlign: 'right', paddingRight: '20px' }}>
                                            <span className="team-name" ng-bind="Sbhavdata[0].Team2Name_Short">ADS </span>
                                            <span className="team-score" ng-bind="Sbhavdata[0].Team2OnlyScore">46-0</span>                                            
                                        </div>
                                    </div>

                                </div> */}
                            </div>
                        ) : (
                            <div >
                                <iframe id="divScore" src={`${scoreSrc}`} style={{ width: '100%', border: '0px', height: '130px', backgroundColor: 'black' }}></iframe>
                            </div>
                        )}


                        <div className="match-box" id="divMatchBhav">
                            <div className="tabel-scroll-2">
                                <table className="market-listing-table">
                                    <thead>
                                        <tr>
                                            <th colSpan="7" className="marketTitle" style={{ textAlign: 'left', background: 'linear-gradient(to right, #622569, #d54be4)',color:'white', height: '50px', verticalAlign: 'middle' }}>
                                                <span className="match-name-team">
                                                    {matchSettings.MatchName} (<span id="apiCallingMethod">1</span>)<br></br>
                                                    (<span id="apiURL"></span>)
                                                </span><br></br>
                                                <span className="match-name-team" id="Browser">
                                                    Browser={matchSettings.Browser}
                                                </span>
                                                <br></br>
                                                <span className="match-name-team" id="SocketStatus">
                                                    Socket Status
                                                </span>
                                                <br></br>
                                                <span className="match-name-team" id="SocketData">
                                                    Socket Data
                                                </span>
                                                <br></br>
                                                <textarea id="ApiData" style={{ height: '300px', width: '300px', whiteSpace: 'pre-wrap' }}></textarea>
                                                <br></br>
                                                
                                                <span className="no_border" style={{ marginLeft: '0px', color: 'black' }}>
                                                    <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
                                                        Book Maker
                                                    </span>
                                                </span>

                                                <span className="no_border"> Min :{matchSettings.BookMakerMinAmount}</span>
                                                <span className="no_border">Max :{matchSettings.BookMakerMaxAmount}</span>
                                                <span style={{ height: '20px', position: 'absolute', right: '0px', top: '1px', bottom: '12px', padding: '2px', textAlign: 'center', background: 'rgb(226, 198, 6)', borderRadius: '10px', width: '60px' }} onClick={toggleScoreHeight}>SCORE</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ margin: '0px', padding: '0px' }}>
                                                {/* <div className="fancy-table">
                                                    <div className="fancy-heads" style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
                                                        <div className="event-sports"></div>
                                                        <div className="fancy_buttons">
                                                            <div className="fancy-backs head-no" style={{ color: 'rgb(0, 0, 0)' }}>LAGAI <i className="fas fa-arrow-circle-down" style={{ color: 'rgb(114, 187, 239)' }}></i>
                                                            </div>
                                                        </div>
                                                        <div className="fancy_buttons">
                                                            <div className="fancy-lays head-yes" style={{ color: 'rgb(0, 0, 0)' }}>KHAI <i className="fas fa-arrow-circle-down" style={{ color: 'rgb(250, 169, 186)' }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}


                                                <table className="table table-striped bulk_actions" style={{ margin: '0px', padding: '0px' }}>
                                                    <tr className="headings mobile_heading" style={{ textTransform: 'uppercase', verticalAlign: 'middle' }}>
                                                        <th width="60%" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white', height: '50px', verticalAlign: 'middle', border: 'solid 1px white' }}>
                                                            RUNNER
                                                        </th>
                                                        <th width="20%" className="back_heading_color" style={{ textAlign: 'center', backgroundColor: 'rgb(99,183,247)', verticalAlign: 'middle', border: 'solid 1px white' }}>LAGAI</th>
                                                        <th width="20%" className="lay_heading_color" style={{ textAlign: 'center', backgroundColor: 'rgb(239,131,155)', verticalAlign: 'middle', border: 'solid 1px white' }}>KHAI</th>
                                                    </tr>
                                                </table>


                                                {matchSettings.Team1 != "" && (
                                                    <div className="f-prio2">
                                                        <div className="fancy-rows list-item">
                                                            <div className="event-sports event-sports-name">
                                                                <div className="event-name" style={{ marginLeft: '0px', color: 'rgb(0, 0, 0)', fontWeight: '700', display: 'block' }}>
                                                                    <img src="/images/team1.png" />
                                                                    <span>{matchSettings.Team1}</span>
                                                                    <br></br>
                                                                    <div style={{ color: allTeamPM.Team1PM > 0 ? 'green' : allTeamPM.Team1PM < 0 ? 'red' : 'black' }} id="Team_BM1PM">
                                                                        {allTeamPM.Team1PM}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="fancy_div">
                                                                <span className="fbox35270">
                                                                    <div className="fancy_buttone" id="Team1BackLay">
                                                                        <div className="fancy-backs bet-button back mark-back BMK" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_k" type="hidden" id="KRate_BM1" name="KRate_BM1" value="0" />
                                                                        </div>
                                                                        <div className="fancy-lays bet-button lay mark-lay BML" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_l" type="hidden" id="LRate_BM1" name="LRate_BM1" value="0" />
                                                                        </div>

                                                                        <div className="ball-running-msg"> <h1>SUSPENDED</h1> </div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {matchSettings.Team2 != "" && (
                                                    <div className="f-prio2">
                                                        <div className="fancy-rows list-item">
                                                            <div className="event-sports event-sports-name">
                                                                <div className="event-name" style={{ marginLeft: '0px', color: 'rgb(0, 0, 0)', fontWeight: '700', display: 'block' }}>
                                                                    <img src="/images/team1.png" />
                                                                    <span>{matchSettings.Team2}</span>
                                                                    <br></br>
                                                                    <div style={{ color: allTeamPM.Team2PM > 0 ? 'green' : allTeamPM.Team2PM < 0 ? 'red' : 'black' }} id="Team_BM1PM">
                                                                        {allTeamPM.Team2PM}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="fancy_div">
                                                                <span className="fbox35270">
                                                                    <div className="fancy_buttone" id="Team2BackLay">
                                                                        <div className="fancy-backs bet-button back mark-back BMK" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_k" type="hidden" id="KRate_BM2" name="KRate_BM2" value="0" />
                                                                        </div>
                                                                        <div className="fancy-lays bet-button lay mark-lay BML" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_l" type="hidden" id="LRate_BM2" name="LRate_BM2" value="0" />
                                                                        </div>

                                                                        <div className="ball-running-msg"> <h1>SUSPENDED</h1> </div>
                                                                    </div>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {matchSettings.Team3 != "" && (
                                                    <div className="f-prio2">
                                                        <div className="fancy-rows list-item">
                                                            <div className="event-sports event-sports-name">
                                                                <div className="event-name" style={{ marginLeft: '0px', color: 'rgb(0, 0, 0)', fontWeight: '700', display: 'block' }}>
                                                                    <img src="/images/team1.png" />
                                                                    <span>{matchSettings.Team3}</span>
                                                                    <br></br>
                                                                    <div style={{ color: allTeamPM.Team3PM > 0 ? 'green' : allTeamPM.Team3PM < 0 ? 'red' : 'black' }} id="Team_BM1PM">
                                                                        {allTeamPM.Team3PM}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="fancy_div">
                                                                <span className="fbox35270">
                                                                    <div className="fancy_buttone" id="Team3BackLay">
                                                                        <div className="fancy-backs bet-button back mark-back BMK" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_k" type="hidden" id="KRate_BM3" name="KRate_BM3" value="0" />
                                                                        </div>
                                                                        <div className="fancy-lays bet-button lay mark-lay BML" style={{ padding: '15px', userSelect: 'none' }}>
                                                                            <strong>
                                                                                <span className="ng-binding">0</span>
                                                                            </strong>
                                                                            <input className="button_l" type="hidden" id="LRate_BM3" name="LRate_BM3" value="0" />
                                                                        </div>

                                                                        <div className="ball-running-msg"> <h1>SUSPENDED</h1> </div>
                                                                    </div>

                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div id="BMBhavDataJSON">

                                                </div>

                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>


                        <div className="match-box">
                            <div style={{ display: 'block', margin: '0px' }}>
                                <div className="" style={{ margin: '0px', padding: '0px' }}>
                                    {/* <div className="fancy-heads">
                                        <div className="event-sports">
                                            <span className="marketTitle blinking">Session <span style={{ float: 'right', background: 'rgb(255, 255, 255)', borderRadius: '15px', padding: '0px 6px', color: 'rgb(8, 131, 148)' }}>𝓲</span>
                                            </span>

                                            <span className="no_border" style={{ marginLeft: '0px' }}>
                                                <span>
                                                    <span className="no_border">Min :{matchSettings.SessionMinAmount}</span>
                                                    <span className="no_border">Max :{matchSettings.SessionMaxAmount}</span>
                                                </span>

                                            </span>

                                        </div>
                                        <div className="fancy_buttons">
                                            <div className="fancy-backs head-no">
                                                <strong>NO</strong>
                                            </div>
                                        </div>
                                        <div className="fancy_buttons">
                                            <div className="fancy-lays head-yes">
                                                <strong>YES</strong>
                                            </div>
                                        </div>
                                    </div> */}

                                    <table className="table table-striped bulk_actions" style={{ margin: '0px', padding: '0px' }}>
                                        <tr className="headings mobile_heading" style={{ textTransform: 'uppercase', verticalAlign: 'middle' }}>
                                            <th width="60%" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white', height: '50px', verticalAlign: 'middle', border: 'solid 1px white' }}>
                                                FANCY
                                            </th>
                                            <th width="20%" className="back_heading_color" style={{ textAlign: 'center', backgroundColor: 'rgb(239,131,155)', verticalAlign: 'middle', border: 'solid 1px white' }}>No</th>
                                            <th width="20%" className="lay_heading_color" style={{ textAlign: 'center', backgroundColor: 'rgb(99,183,247)', verticalAlign: 'middle', border: 'solid 1px white' }}>Yes</th>
                                        </tr>
                                    </table>
                                </div>
                                <div className="fullrow margin_bottom fancybox" id="FancyBhavDataJSON">

                                </div>
                                <br></br>
                                <br></br>
                            </div>
                        </div>

                        {MatchBets.length > 0 && (
                            <div className="right-bet-inner">
                                <div id="MatchUnMatchBetaData">
                                    <div id="accountView" role="main">
                                        <span id="msg_error"></span>
                                        <span id="errmsg"></span>
                                        <div className="balance-panel-body">
                                            <div className="table-responsive sports-tabel">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr className="" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white', height: '50px', verticalAlign: 'middle' }}>
                                                            <td>Team</td>
                                                            <td>Mode</td>
                                                            <td>Rate</td>
                                                            <td>Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {MatchBets.map((row, index) => (
                                                            <tr className="heading_user_table">
                                                                <td>{row.Team}</td>
                                                                <td>{row.Mode === "K" ? "L" : "K"}</td>
                                                                <td>{row.Rate}</td>
                                                                <td>{row.Amount}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {SessionBets.length > 0 && (
                            <div className="right-bet-inner">
                                <div id="MatchUnMatchBetaData">
                                    <div id="accountView" role="main">
                                        <span id="msg_error"></span>
                                        <span id="errmsg"></span>
                                        <div className="balance-panel-body">
                                            <div className="table-responsive sports-tabel">
                                                <table className="table table-bordered table-hover">
                                                    <thead>
                                                        <tr className="" style={{ background: 'linear-gradient(to right, #622569, #d54be4)',color:'white', height: '50px', verticalAlign: 'middle' }}>
                                                            <td>Fancy</td>
                                                            <td>Run</td>
                                                            <td>Mode</td>
                                                            <td>Rate</td>
                                                            <td>Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {SessionBets.map((row, index) => (
                                                            <tr className="heading_user_table">
                                                                <td>{row.Fancy}</td>
                                                                <td>{row.Run}</td>
                                                                <td>{row.Mode}</td>
                                                                <td>{row.Rate}</td>
                                                                <td>{row.Amount}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="match-box text-center" style={{ padding: '10px', marginBottom: '80px', marginTop: '20px' }}>
                            <Link to={`/Dashboard/CompletedFancy/${MatchCode}`}>See All Completed Bets</Link>

                        </div>

                        <div className="">
                            &nbsp;
                        </div>

                        <input name="MatchCode" type="hidden" id="MatchCode" value={MatchCode} />
                        <input name="MatchRate" type="hidden" id="MatchRate" />
                        <input name="MatchTeam" type="hidden" id="MatchTeam" />

                        <input name="Team1" type="hidden" id="Team1" value={matchSettings.Team1} />
                        <input name="Team2" type="hidden" id="Team2" value={matchSettings.Team2} />
                        <input name="Team3" type="hidden" id="Team3" value={matchSettings.Team3} />

                        <input name="SessionName" type="hidden" id="SessionName" />
                        <input name="SessionRun" type="hidden" id="SessionRun" />
                        <input name="SessionRate" type="hidden" id="SessionRate" />
                        <input name="SessionYN" type="hidden" id="SessionYN" />

                        <input name="SessionNRun" type="hidden" id="SessionNRun" />
                        <input name="SessionNRate" type="hidden" id="SessionNRate" />

                        <input name="SessionYRun" type="hidden" id="SessionYRun" />
                        <input name="SessionYRate" type="hidden" id="SessionYRate" />

                        <input name="MatchType" type="hidden" id="MatchType" value={matchSettings.MatchType} />

                        <input name="ServerTime_Select" type="hidden" id="ServerTime_Select" />
                        <input name="ServerTime_Submit" type="hidden" id="ServerTime_Submit" />

                        <input name="DateTimeP" type="hidden" id="DateTimeP" value="1572429898000" />
                        <input name="ServerTime_Formatted" type="hidden" id="ServerTime_Formatted" />

                        <input name="TeamKRate" type="hidden" id="TeamKRate" />
                        <input name="TeamLRate" type="hidden" id="TeamLRate" />
                        <input name="BetTeamindex" type="hidden" id="BetTeamindex" />

                        <input name="SubmitTimeValue" type="hidden" id="SubmitTimeValue" value="" />

                        <input name="SessionMinAmount_Session" type="hidden" id="SessionMinAmount_Session" />
                        <input name="SessionMaxAmount_Session" type="hidden" id="SessionMaxAmount_Session" />

                        <input name="MatchBetChk" type="hidden" id="MatchBetChk" value="" />
                        <input name="SessionBetChk" type="hidden" id="SessionBetChk" value="" />

                        <input name="UserType" id="UserType" type="hidden" value={UserType} />
                        <input name="UserName" id="UserName" type="hidden" value={UserName} />

                        <input name="MatchMinAmount" type="hidden" id="MatchMinAmount" value={matchSettings.MatchMinAmount} />
                        <input name="MatchMaxAmount" type="hidden" id="MatchMaxAmount" value={matchSettings.MatchMaxAmount} />

                        <input name="BookMakerMinAmount" type="hidden" id="BookMakerMinAmount" value={matchSettings.BookMakerMinAmount} />
                        <input name="BookMakerMaxAmount" type="hidden" id="BookMakerMaxAmount" value={matchSettings.BookMakerMaxAmount} />

                        <input name="AmountTimeChk" type="hidden" id="AmountTimeChk" value="" />

                        <input name="MBetType" type="hidden" id="MBetType" value="" />



                    </div>



                </div>
            </section>

            <div id="betSidenav" className="betsidenav">
                <a className="closebtn">x</a>
                <section className="right-bet-content">
                    <div className="betSlipBox" id="betSlipBoxSession" style={{ display: 'none' }}>
                        <div className="betBox bet-slip-box">
                            <span id="msg_error"></span>
                            <span id="errmsg"></span>
                            <div className="lds-dual-ring  loader" style={{ display: 'block' }}></div>
                            <div className="bet-box_inner" id="betBoxColor" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                                    <div style={{ fontWeight: '700' }} id="DisplayBhavName"></div>
                                </div>
                                <div className="inner-bet-section">
                                    <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                        <div className="items odds">
                                            <div className="stack_input_field numbers-row">
                                                <input disabled type="number" className="calProfitLoss odds-input form-control  CommanBtn" value="" id="Rate1_Odds" />
                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="items stake" id=" ">
                                            <div className="stack_input_field numbers-row">
                                                <input type="number" pattern="[0-9]*" step="1" id="MatchAmount" className="calProfitLoss stake-input form-control  CommanBtn" />

                                                <div className="inc plus_btn">
                                                    <span className="plus_btns">+</span>
                                                    <div className="quantity-button quantity-up">
                                                        <i className="fas fa-plus"></i>
                                                    </div>
                                                </div>
                                                <div className="dec plus_btn">
                                                    <span className="minus_btns">-</span>
                                                    <div className="quantity-button quantity-down">
                                                        <i className="fas fa-minus"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bet-btns">
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmount").value = 100; }}>100</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmount").value = 200; }}>200</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmount").value = 500; }}>500</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmount").value = 1000; }}>1K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmount").value = 2000; }}>2K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmount").value = 3000; }}>3K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmount").value = 5000; }}>5K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmount").value = 10000; }}>10K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="20000" onClick={() => { document.getElementById("MatchAmount").value = 20000; }}>20K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="25000" onClick={() => { document.getElementById("MatchAmount").value = 25000; }}>25K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="30000" onClick={() => { document.getElementById("MatchAmount").value = 30000; }}>30K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="50000" onClick={() => { document.getElementById("MatchAmount").value = 50000; }}>50K</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="100000" onClick={() => { document.getElementById("MatchAmount").value = 100000; }}>1Lakh</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="200000" onClick={() => { document.getElementById("MatchAmount").value = 200000; }}>2Lakh</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" chipName1" type="button" value="300000" onClick={() => { document.getElementById("MatchAmount").value = 300000; }}>3Lakh</button>
                                        </div>
                                        <div className="btn brt_btn">
                                            <button className=" " type="button" onClick={() => { document.getElementById("MatchAmount").value = ''; }}>Clear</button>
                                        </div>
                                    </div>
                                    <div className="bet-box-footer">
                                        <button className="btn cancle-bet" type="button" onClick={() => { $('#betSlipBoxSession').css('display', 'none'); clearInterval(myVar1) }}>Cancel</button>
                                        <button className="btn btn-warning" type="button" style={{ width: '20px' }} id="AmountTime"></button>
                                        <button className="btn place-bet" type="button" id="cmdDone" onClick={SubmitBet}>Place Bet</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="overlay_mobile in"></div>

                </section>
            </div>

            <div className="betSlipBox mobile-bet-box" style={{ position: 'fixed', bottom: '0px', zIndex: '999', display: 'none' }} id="betSlipBoxSessionMob">
                <div className="betBox bet-slip-box">
                    <span id="msg_error"></span>
                    <span id="errmsg"></span>
                    <div className="lds-dual-ring  loader" style={{ display: 'none' }}></div>
                    <div className="bet-box_inner bet-box-inner-mobile" id="betBoxColorMob" style={{ backgroundColor: 'rgb(250, 169, 186)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px', margin: '5px', alignItems: 'center' }}>
                            <div style={{ fontWeight: '700' }} id="DisplayBhavNameMob">45 over run SA</div>
                        </div>
                        <div className="inner-bet-section">
                            {/* <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row" style={{ color: 'green' }}>
                                        Profit : <span id="Profit"></span>
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row" style={{ color: 'red' }}>
                                        Loss : <span id="Loss"></span>
                                    </div>
                                </div>
                            </div> */}
                            <div className="oddds-stake-box" style={{ marginBottom: '10px' }}>
                                <div className="items odds">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" disabled className="calProfitLoss odds-input form-control  CommanBtn" value="" id="Rate1_OddsMob" />
                                    </div>
                                </div>
                                <div className="items stake">
                                    <div className="stack_input_field numbers-row">
                                        <input type="number" pattern="[0-9]*" step="1" id="MatchAmountMob" className="calProfitLoss stake-input form-control  CommanBtn" />
                                        <div className="inc plus_btn">
                                            <span className="plus_btns">+</span>
                                            <div className="quantity-button quantity-up">
                                                <i className="fas fa-plus"></i>
                                            </div>
                                        </div>
                                        <div className="dec plus_btn">
                                            <span className="minus_btns">-</span>
                                            <div className="quantity-button quantity-down">
                                                <i className="fas fa-minus"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="bet-btns" align="center">
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="100" onClick={() => { document.getElementById("MatchAmountMob").value = 100; }}>100</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="200" onClick={() => { document.getElementById("MatchAmountMob").value = 200; }}>200</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="500" onClick={() => { document.getElementById("MatchAmountMob").value = 500; }}>500</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="1000" onClick={() => { document.getElementById("MatchAmountMob").value = 1000; }}>1K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="2000" onClick={() => { document.getElementById("MatchAmountMob").value = 2000; }}>2K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="3000" onClick={() => { document.getElementById("MatchAmountMob").value = 3000; }}>3K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="5000" onClick={() => { document.getElementById("MatchAmountMob").value = 5000; }}>5K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="10000" onClick={() => { document.getElementById("MatchAmountMob").value = 10000; }}>10K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="20000" onClick={() => { document.getElementById("MatchAmountMob").value = 20000; }}>20K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="25000" onClick={() => { document.getElementById("MatchAmountMob").value = 25000; }}>25K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="30000" onClick={() => { document.getElementById("MatchAmountMob").value = 30000; }}>30K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="50000" onClick={() => { document.getElementById("MatchAmountMob").value = 50000; }}>50K</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="100000" onClick={() => { document.getElementById("MatchAmountMob").value = 100000; }}>1Lakh</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="200000" onClick={() => { document.getElementById("MatchAmountMob").value = 200000; }}>2Lakh</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" chipName1" type="button" value="300000" onClick={() => { document.getElementById("MatchAmountMob").value = 300000; }}>3Lakh</button>
                                </div>
                                <div className="btn brt_btn">
                                    <button className=" " type="button" onClick={() => { document.getElementById("MatchAmountMob").value = ''; }}>Clear</button>
                                </div>
                            </div>
                            {/* <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={handleCancelClick}>Cancel</button>
                                <button className="btn place-bet" type="button" id="cmdDone" onClick={handlePlaceBet}>Place Bet</button>
                            </div> */}
                            <div className="bet-box-footer">
                                <button className="btn cancle-bet" type="button" onClick={() => { $('#betSlipBoxSessionMob').css('display', 'none'); clearInterval(myVar1) }}>Cancel</button>
                                <button className="btn btn-warning" type="button" style={{ width: '20px' }} id="AmountTimeMob"></button>
                                <button className="btn place-bet" type="button" id="cmdDoneMob" onClick={SubmitBet}>Place Bet</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div tabindex="-1" style={{ position: 'relative', zIndex: '1050', display: 'none' }} id="SessionPosition">
                <div className="">
                    <div className="modal show" role="dialog" tabindex="-1" style={{ display: 'block' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div style={{ background: 'rgb(157, 157, 157)', color: 'rgb(255, 255, 255)' }} className="modal-header">
                                    <h5 className="modal-title">Session Book</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={() => document.getElementById("SessionPosition").style.display = "none"}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div style={{ maxHeight: '400px', overflow: 'scroll' }} className="modal-body">
                                    <table className="table table-striped">
                                        <thead>
                                            <th>Run</th>
                                            <th>Profit/Loss</th>
                                        </thead>
                                        <tbody>
                                            {mySessionPosition.map((row, index) => (
                                                <tr style={{ fontSize: '14px' }}>
                                                    <th>{row.Run}</th>
                                                    <th>
                                                        <span style={{ color: row.Amount >= 0 ? 'rgb(59, 145, 234)' : 'red' }}>{row.Amount}</span>
                                                    </th>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-backdrop show"></div>
                </div>
            </div>

        </>
    )
}

export default MSPosition1;
